(function(){
'use strict';
  angular.module('irricrops')
    .controller("cuartelIrriViewCtrl", [
      "Config",'CuartelRes', 'temporadaFac', 'seguimientoRes', '$q','$timeout',
      'IrriviewFac','$http','$stateParams','global','cuartel_id','isDialog','VinedoRes',
      'menu','$compile','$scope','$templateCache', '$templateRequest','urls',
      function( Config, CuartelRes, temporadaFac,seguimientoRes, $q, $timeout,
      IrriviewFac, $http, $stateParams, global, cuartel_id, isDialog, VinedoRes,
    menu, $compile, $scope, $templateCache, $templateRequest, urls){

        var vm          = this;
        var ur          = 0;
        var cc          = 0;
        var pmp         = 0;
        var chart       = null;
        var isLem       = true;
        var fechaInicio = new Date("2018-02-01"); //fechas para testing
        var fechaFin    = new Date("2018-03-31");

        vm.select1             = null;
        vm.select2             = null;
        vm.temporadaSelected_1 = null;
        vm.temporadaSelected_2 = null;

        vm.relativePositions  = [];
        vm.charts             = [];
        vm.showNotes          = true;
        vm.showSerieLabel     = true;
        vm.conEstados         = false;
        vm.table              = null;
        vm.cuartel            = null; //cuartel.data;
        vm.temporadaSelected  = null;
        vm.loadingGeneral     = true;
        vm.config             = Config;
        vm.isMobile           = false;
        vm.chart              = null;
        vm.yaxis_sensor_index = null;
        vm.stacked            = false;
        vm.sumar              = true;
        vm.filtros            = {};
        vm.comparing          = false;
        vm.vinedo_nombre      = "";

        var resizeFn = function() {
          vm.isMobile = false;
          if(global.responsiveIs("xs sm")){
            vm.isMobile = true;
          }
        };

        $(window).resize(resizeFn);
        resizeFn();


        var normalizarSensor = function(datos, profundidad, sector){
          var datoProfundidad = _.find(sector.sector.profundidades, p => p[0] == profundidad )
          var cc = 0;
          if(datoProfundidad){
            cc = datoProfundidad[2];
          }
          if(cc){
            return _.map(datos, ds => {
              return [ds[0], 100 * ((ds[1]/cc)-1)  ]
            });
          }
          return datos;
        }


        /*
         * reglas usadas para temperatura
         */
        var rulers = [
          {
            name         : "0º",
            warningColor : "#f44336", //menores a 0
            lineColor    : "#f44336",  //red
            num          : 0,
          },
          {
            name         : "7º",
            warningColor : "#fdd835", //menores a 7
            lineColor    : "#fdd835", // yellow
            num          : 7,
          },
          {
            name         : "25º",
            warningColor : "#9ccc65", //menores a 25
            lineColor    : "#9ccc65", //green
            num          : 25,
          },
          {
            name         : "30º",
            warningColor : "#fdd835", //menores a 30
            lineColor    : "#fdd835", // yellow
            num          : 30,
          }
        ];


        //---------------------------------------------------
        //--------- suma de sensores y kc sensor ------------
        //---------------------------------------------------

        /*
         * filtra sectores segun fechaInicio y fechaFin
         * para no crear proceso de datos innecesarios
         * en backend
         */
        var filtrarSectoresSensor = function(sectores, fi, ff){
          if(sectores == null || sectores.length == 0){
            return [];
          }
          var header = sectores[0]; // [fecha, s1, s2, s3]
          var r = [sectores[0]];
          _.each(sectores,function(data, i){
            if(i >0){
              if(moment(data[0]*1000).isBetween(fi, ff)){
                r.push(data);
              }
            }
          });
          return r;
        }


        /*
         * limpia el ruido del arreglo de pendientes validas
         * obtenidas por la suma de sensores (function getZonesSumSensor)
         * limpia los grupos de datos validos (value = 10) que sean menores a 30
         * es decir, borra datos que se consideran ruido
         *
         * menores de 30 datos consecutivos,
         * datos obtenidos cada 15 minutos
         */
        vm.cleanZonesSum = function(arr){
          // cantidad de pendientes validas minimas para mantener
          var tolerancia = 30; //minimo de datos consecutivos
          var aux        = [];
          _.each(arr, function(item, index){
            if(item[1] == 0){
              if(aux.length <= tolerancia){
                _.each(aux, function(n){
                  arr[n][1] = 0;
                });
              }
              aux = [];
            }
            if(item[1] > 0){
              aux.push(index);
            }
          });
        }





        /*
         * se obtiene pendiente de 2 numeros,
         * usado para suma de sensores
         */
        var pendiente = function(y1, y2){
         return Math.abs(y2 - y1);
        }




        /*
         * recibe un objeto moment y un array
         * para busqueda por fecha
         * el array debe tener un parametro [0] unix o
         * compatible con moment(X)
         */
        var getByMoment = function(m, arr){
          var r = null;
          _.each(arr, function(a){
            if(r === null && moment(a[0]).isSame(m, "day")){
              r = a[1];
            }
          });
          return r;
        }


        /*
         * se verifican las pendientes de los datos obtenido desde
         * la serie de suma de sensores
         * pendiente valida = 10
         * pendiente invalida = 0
         */
        var getValidTimes = function(arr, toleranciaPendiente){
          var last                = null
          var r = [];
          _.each(arr, function(item, i){
            var v = 0; // false
            if(last){
              var p = pendiente(last[1], item[1]);
              if( last[1] >= item[1] && p < toleranciaPendiente){
                v = 10; // true
              }
            }
            r.push([
              item[0],
              v
            ]);
            last = item;
          });
          return r
        }



        /*
         * convierte los datos consecutivos (horarios) en
         * datos diarios, para calcular kc de sensor
         * kc = consumo diario del sensor / et0 del dia
         *
         * tolerancia determina cuanto del dia debe ser valido para considerarlo
         * en el calculo de kc, si no tiene, es decir, tiende a tener una pendiente
         * muy inclinada, se considera invalido
         */
        vm.roundDays = function(arr, arrData, arrEt0){
          var dia        = null;
          var dias       = [];
          var tolerancia = 70;
          var retDays    = [];
          var retLabels  = [];

          _.each(arr, function(data, i){
            var m = moment(data[0]);
            if( m.hours() == 0 && m.minutes() == 0){
              //guarda datos del dia anterior
              if(dia !== null){
                dia.p     = _.round((dia.points / dia.num)*100, 2);
                dia.valid = (dia.p >= tolerancia);
                if(i > 0){
                  dia.end   = arrData[i-1][1];
                  dia.delta = Math.abs(dia.init - dia.end);
                }
                dias.push(dia);
              }
              //inicia un dia nuevo
              dia = {
                d      : m.format(),    // fecha string
                init   : arrData[i][1], // dato inicial
                end    : null,          // dato final
                delta  : 0, //init - end
                points : 0, // numero de datos validos
                num    : 0, // numero de datos
                p      : 0, // porsentaje de num validos sobre total
                m      : m, // moment
              };
            }
            if(dia !== null){
              if(data[1] != 0){
                dia.points++;
              }
              dia.num++;
            }
          });


          _.each(dias,function(dia){
            var d = null;
            var et = 0;
            if(dia.valid){
              et = getByMoment(dia.m,arrEt0);
              if(et == 0){
                d = _.round(dia.delta / et, 2);
              }else{
                d = 0;
              }
            }
              retDays.push([
                dia.m.add(12, "hours").unix() * 1000,
                d //dia.delta
              ]);

            if(d){
              retLabels.push([
                dia.m.unix() * 1000,
                //"kc:"+d+" et:"+et+" delta:"+ _.round(dia.delta, 2)
                "<b>kc:</b>" + d + " <br /><b>Consumo</b>:" +  _.round(dia.delta, 2)
              ]);
            }
          });
          return {
            days   : retDays, // array [[unix, delta], ...]
            labels : retLabels // array [[unix, label] ...]
          };
        }





      //si esta en las ultimas horas del dia, obtiene la diferencia y corrige
      //Esto solo sirve para dias, no para datos horarios
      function correctDateData(data) {

        var unix = data[0].unix;
        var m    = moment(unix);
        var diff = 24 - m.hours();

        data.forEach(function(item){
            var i     = moment.unix(item.unix).add(diff, "hours").unix();
            item.unix = i;
        });

      }









        /*
         * funcion determina si la pendiente es valida o no
         * construlle array con 0 o 10 si es que la pendientes es valida
         * (0 y 10 usados con fines de debbuging)
         *
         * devuelve arreglo de deltas, de labels y de validos
         */
        vm.getZonesSumSensor = function(param){
          var arr                 = param.sumSensores;
          var arrEt0              = param.datosEt0;
          //tolerancia de pendiente, que tan empinada la pendiente minimo
          var r = getValidTimes(arr, 0.06 * param.cantidadSensoresSum);
          vm.cleanZonesSum(r);

          var roundDays = vm.roundDays(r, arr, arrEt0);
          //delta de sensores, solo para dias validos
          return {
            delta  : roundDays.days,
            labels : roundDays.labels,
            valid  : r // lista de dias, con valid 100
          }
        }



        /*
         * llama a getZonesSumSensor para recargar datos de kc de sensor
         */
        vm.reloadKcSensor = function(chart){

          var serieEt0           = vm.getSerieBy("tag", "eto", chart)[0];
          var serieKc            = vm.getSerieBy("tag", "kc", chart)[0];
          var serieSum           = vm.getSerieBy("sumId", "ss", chart)[0];
          var seriesSensor       = vm.getSerieBy("sumTo", "ss", chart);

          if(serieSum == undefined){
            return null;
          }
          if(serieKc == undefined){
            return null;
          }

          var datosEt0           = serieEt0.userOptions.data;
          var data               = serieSum.userOptions.data;
          var serieSensorVisible = 0;

          _.each(seriesSensor,function(serie){
            if(serie.visible){
              //serieSensorVisible.push(serie);
              serieSensorVisible++;
            }
          });
          vm.deltasSensor = vm.getZonesSumSensor({
            sumSensores         : data,
            cantidadSensoresSum : serieSensorVisible,
            datosEt0            : datosEt0
          });
          serieKc.setData(vm.deltasSensor.delta, false);
        }






        //---------------------------------------------------
        //---------------------------------------------------
        //---------------------------------------------------




        /*
         * verifica si un periodo es parte de una temporada
         */
        vm.verificarPeriodo = function(estado, temporada) {
          if(temporada == null){
            return false;
          }
          var mi = moment(temporada.inicio, "YYYY-MM-DD");
          var mf = moment(temporada.fin, "YYYY-MM-DD");
          if(estado.dateInicio === undefined){
            if(estado.fecha_inicio !== undefined){
              estado.dateInicio = moment.unix(estado.fecha_inicio).toDate(); //.cleanHour();
            }
            if(estado.inicio !== undefined){
              estado.dateInicio = moment.unix(estado.inicio).toDate(); //.cleanHour();
            }
          }
          var me = moment(estado.dateInicio);
          if (me.isBetween(mi, mf)) {
            return true;
          }
          return false;
        };






        /*
         * convierte hex a rgba
         */
        vm.convertHex = function(hex,opacity){
          if(opacity == undefined){
            opacity = 100;
          }
          var hexFormated = hex.replace('#','');
          var r = parseInt(hexFormated.substring(0,2), 16);
          var g = parseInt(hexFormated.substring(2,4), 16);
          var b = parseInt(hexFormated.substring(4,6), 16);
          var result = 'rgba('+r+','+g+','+b+','+opacity/100+')';
          return result;
        }



        var numToHourString = function (value) {
          var m = moment.duration(parseFloat(value), "hours");
          return Math.floor(m.asHours()) +":"+ (m.minutes() < 10 ? '0':'')+m.minutes();
        };


        function getVarDatosRiego(dataChart, unix, variable) {
          var r = "no found";
          angular.forEach(dataChart, function(riego) {
            if (moment(riego.unix * 1000).isSame(moment(unix), "day")) {
              r = riego[variable];
            }
          });
          return r;
        }












        /*
         * inicio de grafico
         * funcion para iniciar todo
         */
        vm.initChart = function(params){

          vm.comparing   = false;
          var ID_ELEMENT = 'irriview-stock';
          var sector_id  = vm.cuartel.id;

          if(params !== undefined){
            if(params.id_element !== undefined){
              ID_ELEMENT = params.id_element
            }
            if(params.sector_id !== undefined){
              sector_id = params.sector_id;
            }
          }

          //oculta graficos de comparacion
          $(".comparison-charts > .irriview-container").addClass(".hide");


          //INIT PROMISES
          var d = {
            sector_riego_id : sector_id,
            // fecha_inicio    : new Date(vm.temporadaSelected.inicio),
            // fecha_fin       : new Date(vm.temporadaSelected.fin),
            // periodo         : vm.temporadaSelected.periodo
            fecha_inicio : fechaInicio,
            fecha_fin    : fechaFin,
          };

          // /sector-riego/temporada
          var sectorProm = CuartelRes.getTemporada(d).$promise;

          var d = moment(fechaFin).diff(moment(fechaInicio), "days");
          var dataHttp = {
            "sectores_riego_id[]" : [sector_id],
            dias                  : d,
            fecha                 : fechaFin,
            vinedo_id             : vm.cuartel.vinedo_id
          };

          if(params !== undefined && params.dataHttp !== undefined){
            angular.merge(dataHttp, params.dataHttp);
          }

          // /seguimiento/dias
          var analisisProm = seguimientoRes.dias(dataHttp).$promise;

          var promMensajes = CuartelRes.getMensaje({
            sector_riego_id : sector_id,
            fecha_inicio    : fechaInicio,
            fecha_fin       : fechaFin
          });

          var promEstadosSector = CuartelRes.getEstados({
            sector_riego_id : sector_id,
          }).$promise;


          var promEstadosVinedo = VinedoRes.getEstadosFenologicos({
            vinedo_id: vm.cuartel.vinedo_id,
          }).$promise;

          /*
          var promResumen = $http({
            url    : urls.BASE+"/sector-riego/resumen",
            params : {
              fecha_inicio          : moment(fechaInicio).format("DD-MM-YYYY"),
              fecha_fin             : moment(fechaFin).format("DD-MM-YYYY"),
              "sectores_riego_id[]" : [sector_id]
            }
          });
          */

          var promSensores = CuartelRes.getSensores({
            sector_riego_id : sector_id,
            fecha_inicio          : moment(fechaInicio).format("DD-MM-YYYY"),
            fecha_fin             : moment(fechaFin).format("DD-MM-YYYY"),
          }).$promise;





          //THEN PROMISES
          $q.all([
            analisisProm,  // peticion /seguimiento/dias
            sectorProm,    // peticion /sector-riego/temporada
            promMensajes,  // peticion /sector-riego/mensaje
            promEstadosVinedo,   // peticion /sector-riego/estados

            //promResumen,
            promSensores   // peticion /vinedo/sensores
          ]).then(function(res){

            var dataAnalisis         = res[0];              //only merge
            var data                 = res[1];
            vm.mensajes              = res[2].data.mensajes;
            //var estadosCuartel       = res[3].data;
            var estadosCuartel       = _.get(_.find(res[3].data.sectores,{id_sector_riego: vm.cuartel.id}), 'etapas_sector_riego');
            //var dataResumen          = res[4].data.data.sector_riego[0];
            var dataResumen = {dias:[]};
            //var dataSensores         = res[4].data;
            var sectorSensorData     = res[4].data;
            var sectorSensorSelected = _.first(data.data.sectores);
            ur                       = data.data.variables.ur;
            cc                       = data.data.variables.cc;
            pmp                      = data.data.variables.ppm;
            vm.sumar                 = data.data.variables.sumar;

            vm.loadingGeneral          = false;
            vm.table                   = data.data.tabla;
            vm.cuartel.precipitacion   = data.data.precipitacion;
            vm.cuartel.precipitaciones = data.data.precipitaciones;

            //asigna UR, CC, PMP a sector de riego
            /*
            _.each(dataSensores.sectores, function(sectorSensor){
              _.each(sectorSensor.sectores_riego, function(sectorRiego){
                if(sectorRiego.id == sector_id){
                  ur       = sectorSensor.ur;
                  cc       = sectorSensor.cc;
                  pmp      = sectorSensor.pmp;
                  vm.sumar = sectorSensor.sumar;
                  //sectorSensorSelected = sectorSensor;
                }
              });
            });
            */

            if(sectorSensorData && sectorSensorData.sector){
              ur                   = sectorSensorData.sector.ur;
              cc                   = sectorSensorData.sector.cc;
              pmp                  = sectorSensorData.sector.pmp;
              vm.sumar             = sectorSensorData.sector.sumar;
              sectorSensorSelected = sectorSensorData.sector.datos;
            }





            //agrega limite de scholander a datos del sector (array data.data.riego)
            _.each(data.data.riego, function(r, index){
              _.each(estadosCuartel, function(estado){
                var mi = moment(estado.fecha_inicio * 1000);
                var mf = moment(estado.fecha_fin * 1000);
                var m  = moment(r.unix * 1000);
                if(r.limite_scholander === undefined){
                  r.limite_scholander = null;
                }
                if(r.dtx_inf === undefined){
                  r.dtx_inf = 0;
                }
                if(r.dtx_sup === undefined){
                  r.dtx_sup = 0;
                }
                if(m.isBetween(mi, mf, null, "[]")){
                  r.limite_scholander = estado.limite_scholander;
                  r.dtx_inf = estado.dtx_inf || 0;
                  r.dtx_sup = estado.dtx_sup || 0;
                }
              });
            });




            var datosMerge = ["bomba", "porometro", "calibre", "gramaje" ];
            //agrega variables al array data.data.riego (variables de la misma respuesta)
            _.each(data.data.riego, function(r, index){
              _.each(datosMerge, function(dm){
                if(r.unix == data.data[dm].dias[index].unix){
                  r[dm] = data.data[dm].dias[index].cantidad;
                }
              });
            });



            //from dataAnalisis to data.data.riego
            var datosMerge = ["coeficiente", "reposicion_eto", "reposicion_etb",
                              //"riego_real",
                              "eto", "etb",
                              "reposicion_ideal", "volumen_ha", "volumen_total",
                              "volumen_ha_teorico_etb", "volumen_ha_teorico_etb"];



            //agrega variables al array data.data.riego
            _.each(data.data.riego, function(r, index){
              var founded = false;
              var m = moment.unix(r.unix).add(12, "hours");
              _.each(dataAnalisis.data.datos, function(da, indexDa){
                if(m.isSame(moment(da.fecha), "day")){
                  founded = true;
                  _.each(datosMerge, function(dm){
                    r[dm] = da[dm];
                  });
                }
              });
            });


            correctDateData(data.data.riego, name);




            // filtra segun fechaInicio y fechaFin
            /*
            var sectores = null;
            if(sectorSensorSelected){
              sectores = filtrarSectoresSensor(sectorSensorSelected, fechaInicio, fechaFin);
            }*/

            var unixInicioRiego = null;


            // <editor-fold> inicializacion de variables
            var datosEtb           = [];
            var datosEt0           = [];
            var datosEtc           = [];
            var datosProg          = [];
            var datosReal          = [];
            var datosRealHorarios  = [];
            var datosGd            = [];
            var datosHf            = [];
            var datosPrecip        = [];
            var datosEtAcumulada   = [];
            var datosEt0Acumulada  = [];
            var datosEtbAcumulada  = [];
            var datosEtSimulada    = [];
            var datosEtcSimulada   = [];
            var datosRiegoSimulado = [];
            var datosReposicion    = [];
            var datosReposicion2   = [];
            var datosReposicionEto = [];
            var datosReposicionEtb = [];
            var datosGramos        = [];
            var datosCalibre       = [];
            var datosRiegoIdeal    = [];
            var datosScholander    = [];
            var datosTempMax       = [];
            var datosTempMin       = [];
            var datosTempAll       = [];
            var datosLimite        = [];
            var datosDtx           = [];
            var datosDtxRango      = [];
            //</editor-fold>

          angular.forEach(data.data.riego, function (riego) {
            if(riego.temperatura !== null){
              datosTempMax.push([riego.unix*1000, parseFloat(riego.temperatura)]);
            }

            if(riego.temperatura_min !== null){
              datosTempMin.push([riego.unix*1000, parseFloat(riego.temperatura_min)]);
            }

            if(riego.temperatura_min !== null && riego.temperatura !== null){
              if(riego.temperatura_min != 0 && riego.temperatura !=0){
                datosTempAll.push([riego.unix*1000, parseFloat(riego.temperatura_min), parseFloat(riego.temperatura), ]);
              }
            }

            if (riego.cantidad === null ||riego.cantidad === 0) {
            }else{
              datosGramos.push([riego.unix*1000, parseFloat(riego.cantidad)]);
            }
            if (riego.cantidad === null ||riego.cantidad === 0) {
            }else{
              datosCalibre.push([riego.unix*1000, parseFloat(riego.cantidad)]);
            }


            if (riego.reposicion_eto === null || riego.reposicion_eto === 0) {
              //datosReposicionEto.push([riego.unix*1000, null]);
            }else{
              datosReposicionEto.push([riego.unix*1000, parseFloat(riego.reposicion_eto)]);
            }

            if (riego.reposicion === null || riego.reposicion === 0) {
              //datosReposicion.push([riego.unix*1000, null]);
            }else{
              datosReposicion.push([riego.unix*1000, parseFloat(riego.reposicion)]);
            }

            if (riego.reposicion2 === null || riego.reposicion2 === 0) {
              //datosReposicion.push([riego.unix*1000, null]);
            }else{
              datosReposicion2.push([riego.unix*1000, parseFloat(riego.reposicion2)]);
            }



            if (riego.reposicion_etb === null || riego.reposicion_etb === 0) {
              //datosReposicionEtb.push([riego.unix*1000, null]);
            }else{
              datosReposicionEtb.push([riego.unix*1000, parseFloat(riego.reposicion_etb)]);
            }

            if (riego.etb === null || riego.etb === 0) {
              datosEtb.push([riego.unix*1000, null]);
            }else{
              datosEtb.push([riego.unix*1000, _.round(parseFloat(riego.etb), 2)]);
            }

            if (riego.et0 === null || riego.et0 === 0) {
              datosEt0.push([riego.unix*1000, null]);
            }else{
              datosEt0.push([riego.unix*1000, _.round(parseFloat(riego.et0), 2)]);
            }

            if ( riego.etc === null || riego.etc === 0) {
              datosEtc.push([riego.unix*1000, null]);
            }else{
              datosEtc.push([riego.unix*1000, _.round(parseFloat(riego.etc), 2)]);
            }

            if  (riego.riego_programado === null || riego.riego_programado === 0) {
              datosProg.push([riego.unix*1000, null]);
            }else{
              datosProg.push([riego.unix*1000, parseFloat(riego.riego_programado)]); //XXX no viene
            }

            if  (riego.riegoIdeal ===  undefined || riego.riegoIdeal === 0) {
              datosRiegoIdeal.push([riego.unix*1000, null]);
            }else{
              datosRiegoIdeal.push([riego.unix*1000, parseFloat(riego.riegoIdeal)]);
            }

            if  (riego.riego_real === null || riego.riego_real === 0) {
              datosReal.push([riego.unix*1000, null]);
            }else{
              datosReal.push([riego.unix*1000, _.round(parseFloat(riego.riego_real), 1)]);
              if(unixInicioRiego === null){
                unixInicioRiego = riego.unix;
              }
            }



            if  (riego.riego_real === null || riego.riego_real === 0) {
              datosRealHorarios.push([riego.unix*1000, null]);
            }else{
              var horas_d = moment.duration(riego.hora_inicio_r);
              var horas = horas_d.hours();
              var minutos = horas_d.minutes();
              var segundos = horas_d.seconds();
              var unix_r = moment.unix(riego.unix)
                                .set("hour", horas)
                                .set("minutes",minutos)
                                .set("seconds",segundos).unix() * 1000;

              var diffUnix = riego.riego_real_h * 60 * 60 * 1000;
              datosRealHorarios.push([unix_r - 1,0]);
              datosRealHorarios.push([unix_r, _.round(parseFloat(riego.riego_real), 1)]);
              datosRealHorarios.push([unix_r + diffUnix, _.round(parseFloat(riego.riego_real), 1)]);
              datosRealHorarios.push([unix_r + diffUnix +1 , 0]);

              if(unixInicioRiego === null){
                unixInicioRiego = riego.unix;
              }
            }

            if  (riego.horas_frio === null || riego.horas_frio === 0) {
              datosHf.push([riego.unix*1000, null]);
            }else{
              datosHf.push([riego.unix*1000, _.round(parseFloat(riego.horas_frio ))]);
            }

            if  (riego.grados_dia=== null || riego.grados_dia=== 0) {
              datosGd.push([riego.unix*1000, null]);
            }else{
              datosGd.push([riego.unix*1000, parseFloat(riego.grados_dia)]);
            }

            if  (riego.precipitacion === null || riego.precipitacion === 0) {
              datosPrecip.push([riego.unix*1000, null]);
            }else{
              datosPrecip.push([riego.unix*1000, _.round(parseFloat(riego.precipitacion), 2)]);
            }

            if  (riego.et0_acum === null || riego.et0_acum === 0) {
              datosEt0Acumulada.push([riego.unix*1000, null]);
            }else{
              if(unixInicioRiego !== null && riego.unix >= unixInicioRiego){
                datosEt0Acumulada.push([riego.unix*1000, parseFloat(riego.et0_acum)]);
              }else{
                datosEt0Acumulada.push([riego.unix*1000, null]);
              }
            }

            if  (riego.et === null || riego.et === 0) {
              datosEtAcumulada.push([riego.unix*1000, null]);
            }else{
              datosEtAcumulada.push([riego.unix*1000, parseFloat(riego.et)]);
            }

            if  (riego.etb_acum === null || riego.etb_acum === 0) {
              datosEtbAcumulada.push([riego.unix*1000, null]);
            }else{
              datosEtbAcumulada.push([riego.unix*1000, parseFloat(riego.etb_acum)]);
            }

            if  (riego.etc_acum_simulada === null || riego.etc_acum_simulada === 0) {
              datosEtcSimulada.push([riego.unix*1000, null]);
            }else{
              datosEtcSimulada.push([riego.unix*1000, _.round(parseFloat(riego.etc_acum_simulada), 2)]);
            }

            if  (riego.et_acum_simulada === null || riego.et_acum_simulada === 0) {
              datosEtSimulada.push([riego.unix*1000, null]);
            }else{
              datosEtSimulada.push([riego.unix*1000, _.round(parseFloat(riego.et_acum_simulada), 2)]);
            }

            if  (riego.riego_simulado === null || riego.riego_simulado=== 0) {
              datosRiegoSimulado.push([riego.unix*1000, null]);
            }else{
              datosRiegoSimulado.push([riego.unix*1000, parseFloat(riego.riego_simulado)]);
            }

            if  (riego.bomba === null || riego.bomba === 0) {
              datosScholander.push([riego.unix*1000, null]);
            }else{
              datosScholander.push([riego.unix*1000, parseFloat(riego.bomba)]);
            }

            if  (riego.limite_scholander === null || riego.limite_scholander === 0) {
              datosLimite.push([riego.unix*1000, null]);
            }else{
              datosLimite.push([riego.unix*1000, parseFloat(riego.limite_scholander )]);
            }

            if  (riego.dtx_sup === null) {
              datosDtxRango.push([riego.unix*1000,0,0]);
            }else{
              datosDtxRango.push([riego.unix*1000, parseFloat(riego.dtx_inf), parseFloat(riego.dtx_sup)]);
            }

          });




            var irriviewChart = new IrriviewFac({
              title    : vm.cuartel.nombre,
              subtitle : vm.vinedo_nombre,
              tooltip:{
                shared:true,
                split:false,
                valueDecimals: 2,
                useHTML:true,
              },
              events   : {
                redraw : function(e){
                  var that = this;
                  $timeout(function(){

                    /*
                     * vm.relativePositions  es para posicionar
                     *  botones unfold (botones que agrandan los graficos)
                     */
                    vm.relativePositions = irriviewChart.getRelativePositions();
                    vm.plotHeight        = that.plotHeight;
                    vm.plotTop           = that.plotTop;

                    _.each(vm.relativePositions, function(p){
                      if(typeof p.top == "string"){
                        p.top = (parseFloat(p.top)/100) * vm.plotHeight;
                      }
                      if(typeof p.height== "string"){
                        p.height = (parseFloat(p.height )/100) * vm.plotHeight;
                      }
                    });
                  });
                },
                legendItemClick: function(){
                  //tomas todas las series con sumTo:"ss" y los suma hacia sumId:"ss"
                  vm.reloadSum("ss", this.chart, false);
                  vm.reloadProm("ss", this.chart, false);
                  //vm.reloadKcSensor(this.chart);
                  //vm.reloadIndex("asd", this.chart);
                },
                load: function(e){
                  vm.reloadSum("ss", this, false);
                  vm.reloadProm("ss", this, false);
                  if(vm.conEstados){
                    vm.showAllEstados();
                  }
                  //vm.reloadKcSensor(this);
                  var t = temporadaFac.getActualTemporada();
                  if(t.periodo == vm.temporadaSelected.periodo){
                    this.xAxis[0].setExtremes(
                      moment().subtract(5, "month").unix() * 1000,
                      moment().add(1, "month").unix() * 1000
                    );
                  }
                }
              }
            }); //end new IrriviewFac

            vm.expandChart = irriviewChart.expandChart;
            vm.reloadSum   = irriviewChart.reloadSum;
            vm.reloadProm  = irriviewChart.reloadProm;
            //vm.reloadIndex = irriviewChart.reloadIndex;
            vm.getSerieBy  = irriviewChart.getSerieBy;






            // <editor-fold> determina ejes para datos

            var yaxis_temp_index = undefined;
            var yaxis_gd_index  = undefined;
            /*
            yaxis_temp_index = irriviewChart.addYAxis({
              text     : 'temperatura',
              position : 0,
              background: "rgba(0, 0, 0, 0.1)"
            });
            */

            yaxis_gd_index = irriviewChart.addYAxis({
              text     : 'grados Dia',
              position : 0,
              visible  : false,
            });

            var yaxis_sch_index = irriviewChart.addYAxis({
              text     : 'Scholander',
              position : 0,
              visible  : false
            });

            var yaxis_mm_index = irriviewChart.addYAxis({
              text     : 'mm',
              position : 0,
            });

            var yaxis_porcentaje_index = irriviewChart.addYAxis({
              text     : 'porcentaje',
              position : 0,
              opposite : true,
              //visible  : false,
            });

            var yaxis_volume_index = irriviewChart.addYAxis({
              text     : 'volume',
              position : 0,
              visible  : false,
            });

            var yaxis_dtx_index = undefined;
            if(vm.config.vinedo.mai){
              yaxis_dtx_index = irriviewChart.addYAxis({
                text     : 'dtx',
                position : 0,
              });
            }


            var yaxis_ss_index = undefined;
            var yaxis_in_index = undefined;
            if(sectorSensorData.sector && sectorSensorData.sector.datos.length > 0){

              var yaxis_ss_index = irriviewChart.addYAxis({
                text     : 'humedad',
                position : 1,
              });

              var yaxis_in_index = irriviewChart.addYAxis({
                text     : 'indice',
                position : 1,
                visible:false
              });

              var yaxis_sensor_index = irriviewChart.addYAxis({
                text     : 'humedad',
                position : 1,
                //background: "rgba(0, 0, 0, 0.1)",
                stackeable:{
                  enabled: true,
                  //min: 0,
                  //max: 60,
                }
              });

            vm.yaxis_sensor_index = yaxis_sensor_index;

            }
            //</editor-fold>




            //<editor-fold> Agrega las series de datos en irriviewChart

            irriviewChart.addSerie(
              {
                id         : _.random(10, 100000),
                name       : 'Etc',
                color      : Config.colors.etc.background,
                data       : datosEtc,
                visible    : false,
                type       : 'area',
                step       : "left",
                yAxis      : yaxis_mm_index,
                pointRange : 24 * 3600 * 1000,
                tooltip    : {
                  valueSuffix: " mm"
                },
                ruler      : {
                  enabled : true,
                  delta   : false,
                  sum     : true
                },
                dataGrouping:{
                  units: [[
                    'day',
                    [1]
                  ]]
                }
              }
            );

            irriviewChart.addSerie(
              {
                id          : _.random(10, 100000),
                name        : 'Et0',
                color       : Config.colors.et0.alt,
                fillOpacity : 1,
                data        : datosEt0,
                type        : 'area',
                step        : "left",
                tag         : "eto",
                yAxis       : yaxis_mm_index,
                pointRange  : 24 * 3600 * 1000,
                tooltip    : {
                  valueSuffix: " mm"
                },
                visible   : false, //Config.vinedo['estacionMet'],
                /*dataLabels  : {
                  enabled: true,
                  align: "left",
                  x: 5
                },*/
                ruler      : {
                  enabled: true,
                  delta:false,
                  sum: true
                }
              }
            );



            irriviewChart.addSerie({
                name        : 'Et0 acum',
                color       : Config.colors.et0.alt,
                fillOpacity : 1,
                data        : datosEt0Acumulada,
                type        : 'spline',
                yAxis       : yaxis_mm_index,
                tooltip    : {
                  valueSuffix: " mm"
                },
                pointRange  : 24 * 3600 * 1000,
                //visible   : Config.vinedo['estacionMet'],
                visible: false,
                ruler      : {
                  enabled: true,
                  delta:false,
                  sum: true
                }
              });


            irriviewChart.addSerie({
                name        : 'Etb acum',
                color       : Config.colors.etb.alt,
                fillOpacity : 1,
                data        : datosEtbAcumulada,
                type        : 'spline',
                yAxis       : yaxis_mm_index,
                tooltip    : {
                  valueSuffix: " mm"
                },
                pointRange  : 24 * 3600 * 1000,
                //visible   : Config.vinedo['estacionMet'],
                ruler      : {
                  enabled: true,
                  delta:false,
                  sum: true
                }
              });





            irriviewChart.addSerie(
              {
                id          : _.random(10, 100000),
                name        : 'Etb',
                color       : Config.colors.etb.background,
                fillOpacity : 1,
                data        : datosEtb,
                type        : 'area',
                step        : "left",
                tag         : "eto",
                yAxis       : yaxis_mm_index,
                tooltip    : {
                  valueSuffix: " mm"
                },
                pointRange  : 24 * 3600 * 1000,
                visible   : false, //Config.vinedo['conBandeja'],
                /*
                dataLabels  : {
                  enabled: true,
                  align: "left",
                  x: 5
                },
                */
                ruler      : {
                  enabled: true,
                  delta:false,
                  sum: true
                }
              }
            );



            if(!vm.config.vinedo.mai){
              irriviewChart.addSerie({
                id                  : _.random(10, 100000),
                name                : 'limite scholander',
                data                : datosLimite,
                lineColor           : Config.colors.scholander.background,
                color               : Config.colors.scholander.background,
                fillOpacity         : 0.2,
                type                : 'area',
                yAxis               : yaxis_sch_index,
                lineWidth           : 1,
                //enableMouseTracking : false,
                step                : "left",
                //dashStyle           : "DashDot"
              }
            );
          }





            irriviewChart.addSerie({
                id         : _.random(10, 100000),
                name       : 'Scholander',
                data       : datosScholander,
                color      : Config.colors.scholander.background,
                type       : 'spline',
                yAxis      : yaxis_sch_index,
                tooltip    : {
                  valueSuffix: " bar",
                  valuePreffix: "-"
                },
                pointRange : 24 * 3600 * 1000,
                lineWidth  : 1,
                marker     : {
                  enabled:true,
                  radius: 4,
                  symbol:"triangle-down"
                },
                dataLabels:{
                  enabled: true
                }
              }
            );


            /*
            irriviewChart.addSerie({
              id         : _.random(10, 100000),
              name       : 'Reposición Eto',
              data       : datosReposicionEto,
              color      : Config.colors.riegoReal.background,
              type       : 'spline',
              yAxis      : yaxis_porcentaje_index,
              visible:false,
              tooltip    : {
                valueSuffix: "%",
              },
            });


            irriviewChart.addSerie({
              id         : _.random(10, 100000),
              name       : 'Reposición Etb',
              data       : datosReposicionEtb,
              color      : Config.colors.etb.background,
              type       : 'spline',
              yAxis      : yaxis_porcentaje_index,
              visible:false,
              tooltip    : {
                valueSuffix: "%",
              },
            });
            */


            irriviewChart.addSerie({
              id         : _.random(10, 100000),
              name       : 'Reposición',
              data       : datosReposicion,
              color      : Config.colors.riegoReal.background,
              type       : 'spline',
              yAxis      : yaxis_porcentaje_index,
              //visible:false,
              tooltip    : {
                valueSuffix: "%",
              },
            });

            /*
            irriviewChart.addSerie({
              id         : _.random(10, 100000),
              name       : 'Reposición 2',
              data       : datosReposicion2,
              color      : Config.colors.riego,
              type       : 'spline',
              yAxis      : yaxis_porcentaje_index,
              visible:false,
              tooltip    : {
                valueSuffix: "%",
              },
            });
            */








            irriviewChart.addSerie({
              id         : _.random(10, 100000),
              name       : 'Riego Real',
              data       : datosReal,
              color      : Config.colors.riegoReal.background,
              type       : 'column',
              yAxis      : yaxis_mm_index,
              pointRange : 24 * 3600 * 1000,
              dataLabels:{
                enabled: true,
                color      : Config.colors.riegoReal.background,
              },
              tooltip    : {
                valueSuffix: " mm",
            pointFormatter : function() {
              var icon = '<i class="fa fa-square" aria-hidden="true"></i>';
              return '<span style="color:' +Config.colors.riegoReal.background +
                '">'+icon+'</span> Riego Real: <span style="white-space:nowrap; font-weight: bold">'+
                getVarDatosRiego(data.data.riego, this.x, "riego_real")+'mm - '+
                numToHourString(getVarDatosRiego(data.data.riego, this.x, "riego_real_h"))+' Hrs</span></br>';
            }



              },
              ruler      : {
                enabled : true,
                delta   : false,
                sum     : true
              }
            });







            if(vm.config.vinedo['front_sensor_continuo_aa']){

              //limpia array
              datosRealHorarios = _.filter(datosRealHorarios,function(d){return d[1]!=null});

              //ordena los datos antes
              datosRealHorarios.sort(function(a,b) {
                return a[0]-b[0]
              });

              irriviewChart.addSerie( 
                {
                  id         : _.random(10, 100000),
                  name       : 'Riego Real Horario',
                  color      : Config.colors.riegoReal.contrast,
                  data       : datosRealHorarios,
                  type       : 'area',
                  yAxis      : yaxis_mm_index,
                  pointRange : 24 * 3600 * 1000,
                  tooltip    : {
                    valueSuffix: " mm"
                  },
                  ruler      : {
                    enabled : true,
                    delta   : false,
                    sum     : true
                  },
                  dataGrouping:{
                    units: [[
                      'month',
                      [100]
                    ]]
                  }
                }
              );
            }












            irriviewChart.addSerie(
                {
                  id         : _.random(10, 100000),
                  name       : 'Riego Programado',
                  data       : datosProg,
                  color      : Config.colors.riegoProgramado.background,
                  type       : 'column',
                  yAxis      : yaxis_mm_index,
                  pointRange : 24 * 3600 * 1000,
                  visible    : false,
                  tooltip    : {
                    valueSuffix: " mm",
                  },
                }
            );


            irriviewChart.addSerie(
              {
                id         : _.random(10, 100000),
                name       : 'Precipitaciones',
                color      : Config.colors.precipitacion.background,
                data       : datosPrecip,
                type       : 'column',
                yAxis      : yaxis_mm_index,
                pointRange : 24 * 3600 * 1000,
                  tooltip    : {
                    valueSuffix: " mm",
                  },
              }
            );

            /*
            irriviewChart.addSerie(
              {
                id         : _.random(10, 100000),
                name       : 'Reposicion',
                data       : datosReposicion,
                color      : Config.colors.riegoReal.background,
                type       : 'spline',
                yAxis      : 4,
                pointRange : 24 * 3600 * 1000,
                visible    : false
              }
            );
            */

            if(yaxis_temp_index !== undefined){
              irriviewChart.addSerie(
                {
                  id      : _.random(10, 100000),
                  name    : 'temperaturaMax',
                  color   : Config.colors.temperatura.max,
                  data    : datosTempMax,
                  type    : 'spline',
                  yAxis   : yaxis_temp_index,
                  visible : false,
                  tooltip    : {
                    valueSuffix: " ºC",
                  },
                }
              );

              irriviewChart.addSerie(
                {
                  id      : _.random(10, 100000),
                  name    : 'temperaturaMin',
                  color   : Config.colors.temperatura.min,
                  data    : datosTempMin,
                  type    : 'spline',
                  yAxis   : yaxis_temp_index,
                  visible : false,
                  tooltip    : {
                    valueSuffix: " ºC",
                  },
                }
              );
            }








            // DTX add serie
            //TODO: revisar , falta verificar que la peticion tenga delta_mai
            _.forEach(dataResumen.dias, function(dia){
              datosDtx.push([dia.unix * 1000, dia.delta_mai]);
            });

            irriviewChart.addSerie({
              id        : _.random(9, 99999),
              name      : 'dtx',
              data      : datosDtx,
              type      : 'spline',
              lineWidth : 2,
              marker    : {
                enabled : true,
                radius  : 2,
                symbol  : "triangle-up"
              },
              dataLabels:{
                enabled : true
              },
              yAxis     : yaxis_dtx_index,
            });

            irriviewChart.addSerie({
              id          : _.random(9, 99999),
              name        : 'rango dtx',
              type        : "arearange",
              color: "black",
              fillOpacity: 0.3,
              data        : datosDtxRango,
              yAxis       : yaxis_dtx_index,
              lineWidth   : 0,
              marker      : {
                enabled: false
              }
            });












            var dataSensor       = {};
            var correlacion      = {};
            var dataSumSensores  = [];
            var dataPromSensores = [];

            if(sectorSensorData.sector && sectorSensorData.sector.datos.length > 0){
              /*
               * lee array de sectores (sectores sensor)
               * con orden [[fecha, s1, s2, s3...]]
               * correlaciona las alturas con los datos y genera dataSensor[altura] = [[unix, dato]]
               * genera dataSumSensores con formato [[unix, sumaAlturas]]
               * genera dataPromSensorescon formato [[unix, promedioAlturas]]
               *
               */
              _.each(sectorSensorData.sector.datos, function(sensor, index){
                if(index == 0){ //la posicion 0 es para determinar las alturas, no contiene datos
                  _.each(sensor, function(h, i){
                    if(i >0){
                      dataSensor[h] = [];
                      correlacion[i] = h;
                    }
                  });
                }else{
                  var unix = moment.utc(sensor[0], "X").unix() * 1000;
                  var sum  = 0;
                  var count = 0;
                  _.each(sensor, function(d, i){
                    if(i >0){
                      dataSensor[correlacion[i]].push([unix , _.round(d, 2)]);
                      sum += d;
                      count ++;
                    }
                  });
                  dataSumSensores.push([unix , _.round(sum, 1)]);
                  dataPromSensores.push([unix , _.round(sum / count- 1, 1)]);
                }
              });

              var fn = function(a) {
                return a[0];
              }

              dataSensor = _.forEach(dataSensor,function(d,i){ dataSensor[i] = _.sortBy(d, fn)});
              dataSumSensores  = _.sortBy(dataSumSensores, fn);
              dataPromSensores = _.sortBy(dataPromSensores, fn);



              _.each(dataSensor, function(ds, index){

                if(isLem){
                  ds = normalizarSensor(ds, index, sectorSensorData);
                }
                
                irriviewChart.addSerie({
                  id      : _.random(10, 100000),
                  type    : 'line',
                  abbr    : "s "+index,
                  name    : "sensor "+index+"cm",
                  profundidad: parseFloat(index),
                  data    : ds,
                  sumTo   : "ss",
                  promTo  : "ss",
                  stackeable      : true,
                  indexTo : "",
                  tooltip    : {
                    valueSuffix: " %",
                  },
                  ruler   : {
                    enabled : true,
                    delta   : true,
                    sum     : false
                  },
                  yAxis         : yaxis_sensor_index,
                });
              });




              if(yaxis_in_index !== undefined){
                irriviewChart.addSerie({
                  id           : _.random(10, 100000),
                  name         : "kc",
                  tag          : "kc",
                  type         : 'spline',
                  lineWidth    : 0,
                  //data         : deltasSensor.delta,
                  data         : [],
                  yAxis        : yaxis_in_index,
                  color        : "orange",
                  dataGrouping : {enabled: false},
                  tooltip      : {
                    pointFormatter: function(){
                      if(vm.deltasSensor){
                        return getByMoment(moment(this.x), vm.deltasSensor.labels);
                      }
                    }
                  },
                  marker       : {
                    enabled: true,
                    radius: 2
                  },
                  dataLabels: {
                    enabled: true
                  },
                });
              }



              if(yaxis_ss_index !== undefined){
                irriviewChart.addSerie({
                  id              : _.random(10, 100000),
                  name            : "promedio sensores",
                  abbr            : "prom",
                  promId          : "ss",
                  type            : "line",
                  data            :dataPromSensores,
                  yAxis           : yaxis_ss_index,
                  color           : "black",
                  showInNavigator : true,
                  //visible: !vm.sumar,
                  visible: false,
                  tooltip    : {
                    valueSuffix: " %",
                  },
                  ruler           : {
                    enabled : true,
                    delta   : true,
                    sum     : false
                  },
                  datagrouping      : {
                    grouppixelwidth : 1,
                    units           : [[
                      'minute',
                      [15, 30]
                    ],[
                      'hour',
                      [1,6]
                    ]]
                  }
                });
              }








              if(yaxis_ss_index !== undefined){
                irriviewChart.addSerie({
                  id              : _.random(10, 100000),
                  name            : "suma sensores",
                  abbr            : "ss",
                  sumId           : "ss",
                  type            : "line",
                  data            : dataSumSensores,
                  yAxis           : yaxis_ss_index,
                  color           : "black",
                  visible: vm.sumar,
                  showInNavigator : true,
                  tooltip    : {
                    valueSuffix: " %",
                  },
                  ruler           : {
                    enabled : true,
                    delta   : true,
                    sum     : false
                  },
                  datagrouping      : {
                    grouppixelwidth : 1,
                    units           : [[
                      'minute',
                      [15, 30]
                    ],[
                      'hour',
                      [1,6]
                    ]]
                  }
                });
              }








              //var pmp         = data.data.variables.ppm; // backend typo
              //var cc          = data.data.variables.cc;
              //var ur          = data.data.variables.saturacion;
              var coeficiente = 1;

              /*
              if(data.data.sectores.length > 0 &&
                data.data.sectores[0].length > 0 &&
                data.data.sectores[0][0].length > 0){
                coeficiente = data.data.sectores[0][0].length - 1;
              }
              */

              ur  *= coeficiente;
              pmp *= coeficiente;
              cc  *= coeficiente;

              if (ur > 0){
                irriviewChart.addPlotLineY({
                  color : Config.colors["ur"].background,
                  width : 2,
                  value : ur,
                  yAxis: yaxis_sensor_index,
                  label : {
                    text      : "UR "+ur+"%",
                    align     : "right",
                    textAlign : "right",
                    x         : -20
                  }
                });
              }

              if (cc > 0) {
                irriviewChart.addPlotBandY({
                  color : Config.colors["saturacion"].backgroundRGBA,
                  to    : cc + 50,
                  from  : cc,
                  yAxis: yaxis_sensor_index,
                  label : {
                    text      : "Sat > " + cc + "%",
                    align     : "right",
                    textAlign : "right",
                    x         : -20
                  },
                });

                irriviewChart.addPlotBandY({
                  color  : Config.colors["cc"].backgroundRGBA,
                  to     : pmp,
                  from   : cc,
                  yAxis: yaxis_sensor_index,
                  labels : {
                    text      : "CC " + cc + "%",
                    align     : "right",
                    textAlign : "right",
                    x         : -20
                  },
                });
              }  // end cc > 0

              if (pmp > 0) {
                irriviewChart.addPlotBandY({
                  color : Config.colors["pmp"].backgroundRGBA,
                  to    : pmp,
                  from  : pmp - 10,
                  yAxis: yaxis_sensor_index,
                  label : {
                    text      : "pmp " + pmp + "%",
                    align     : "right",
                    textAlign : "right",
                    x         : -20
                  },
                });
              } //end pmp > 0
            } // end if sectores.length > 0

            //var axis = 1;



            var serieTempId = _.random(10, 100000);

            if(yaxis_temp_index !== undefined){
              irriviewChart.addSerie({
                id        : serieTempId,
                name      : 'temperatura',
                data      : datosTempAll,
                type      : 'arearange',
                yAxis     : yaxis_temp_index,
                color     : "#f44336",
                fillColor : "#f44336",
                tooltip    : {
                  valueSuffix: " ºC",
                },
                zones     : []
              });
            }


            if(yaxis_gd_index !== undefined){
              irriviewChart.addSerie({
                id      : _.random(10, 100000),
                name    : 'grados Dia',
                color   : Config.colors.gd.background,
                data    : datosGd,
                type    : 'spline',
                yAxis   : yaxis_gd_index,
                visible : false
              });

              irriviewChart.addSerie({
                id      : _.random(10, 100000),
                name    : 'Horas Frio',
                color   : Config.colors.etb.background,
                data    : datosHf,
                type    : 'spline',
                yAxis   : yaxis_gd_index,
                visible : false
              });
            }


            _.each( rulers, function(r){

              if((r.line === undefined || r.line) && yaxis_temp_index !== undefined){
                irriviewChart.addPlotLineY({
                  color     : r.lineColor,
                  yAxis     : yaxis_temp_index,
                  width     : 1,
                  value     : r.num,
                  dashStyle : "longdashdotdot",
                  label     : {
                    text      : r.name,
                    align     : "right",
                    textAlign : "right",
                    x         : -20,
                    style     : {
                      //color: r.lineColor,
                    }
                  }
                });
              }

              irriviewChart.addSerieZone({
                serieId   : serieTempId,
                color     : r.warningColor,
                fillColor : r.fillColor || r.warningColor,
                value     : r.num
              });

            });




            var dataMensajes = [];
            _.each(vm.mensajes, function(m){
              if(m.mensajes !== undefined && m.mensajes[0].msj !== ""){
                var date = moment(m.unix * 1000).format("DD, MMM");
                var newM = {
                  x     : m.unix * 1000,
                  title : "msj",
                  //title   : '<span class="msj-icon"><i class="material-icons">chat</i></span>',
                  //m.mensajes[0].nombre_user,
                  text  : m.mensajes[0].msj,
                  name  : "<b>"+m.mensajes[0].nombre_user+" : </b> <i class='md-blue'>"+ date + "</i>",
                };
                dataMensajes.push(newM);
              }
            });



            irriviewChart.addSerie({
              name      : "mensajes",
              data      : dataMensajes,
              type      : "flags",
              yAxis     : yaxis_mm_index,
              shape     : 'flag',
              className:"serie-mensajes",
              useHTML   : true,
              lineColor : "#616161",
              fillColor : "#616161",
              color     : "#fff",
              lineWidth : 2,
              y         : -40,
              label:{
                style:{
                  color: "red"
                }
              },
              states    : {
                hover:{
                  fillColor: "#424242",
                  brightness: 0
                }
              }
            });










            var dataFertMensajes = [];
            _.each(dataResumen.dias, function(dia){
              if(dia.regue && dia.aplicacion && dia.aplicacion[0]){
                var date = moment(dia.unix * 1000).format("DD, MMM");
                var newM = {
                  x     : dia.unix * 1000,
                  name  : "<b> Fert Real : </b> <i class='md-blue'>"+ date + "</i>",
                  title : "F",
                  //title   : '<span class="msj-icon"><i class="material-icons">chat</i></span>',
                  text  : ""+_.map(dia.aplicacion, function(apl){
                    return apl.producto_abr;
                  }).join(", "),
                };
                dataFertMensajes.push(newM);
              }
            });


            irriviewChart.addSerie({
              name      : "Fertilización",
              data      : dataFertMensajes,
              type      : "flags",
              yAxis     : yaxis_mm_index,
              shape     : 'circlepin',
              className : "serie-fert-mensajes",
              useHTML   : true,
              lineColor : "#00796b",
              fillColor : "#00796b",
              color     : "#fff",
              lineWidth : 2,
              width     : 10,
              y         : -5,
              style     : {
                fontSize: "10px",
                color     : "#fff",
              },
              states : {
                hover : {
                  fillColor  : "#424242",
                  brightness : 0
                }
              }
            });

            //</editor-fold>


            irriviewChart.addTodayLine();
            var chart = irriviewChart.show(ID_ELEMENT);
            vm.chart  = chart; // usado en unstackHSSeries
            var chartData = {
              sector_id  : sector_id,
              estados    : estadosCuartel,
              chart      : chart,
              temporada  : vm.temporadaSelected,
              estadosIds : []
            };

            vm.charts.push(chartData);

            var estadosHTMLContent = $("<div ng-repeat='c in iv.charts' ng-show='c.sector_id == "+sector_id+" && c.temporada.periodo == \""+vm.temporadaSelected.periodo+"\" '>"+"</div>");
            estadosHTMLContent.addClass("estados-lista");
            var templateUrl = 'components/cuartel/irriview/listaEstados_tmpl.html';

            $templateRequest(templateUrl).then(function(template) {
              estadosHTMLContent.append(template);
              $compile(estadosHTMLContent).bind(vm)($scope);
              $("#"+ID_ELEMENT).prepend(estadosHTMLContent);
            }, function() {
              // An error has occurred
            });



            //stackHSSeries(chart, yaxis_sensor_index);

            $('#'+ID_ELEMENT)
            .find(".highcharts-navigator, .highcharts-scrollbar, .highcharts-legend")
              .on("mouseover", function(e){
                $timeout(function(){
                  vm.showNotes = false;
                  //vm.showSerieLabel = false;
                })
              }).on("mouseleave", function(e){
                $timeout(function(){
                  vm.showNotes = true;
                  //vm.showSerieLabel = true;
                });
              });


          });
        };





















        vm.initChartComparison = function(params){

          vm.comparing      = true;
          var sectores_id   = params.sectores_id; // []
          var elements_ids  = params.elements_ids;
          var sectores_name = params.sectores_name;
          var temporadas    = params.temporadas;

          $("#comparison-charts").html("");


          _.each(sectores_id, function(sector_id, i){

            var idRandom = _.random(100000,999999);

            var a = $("<div></div>")
            .addClass("md-whiteframe-z2")
            .addClass("irriview-container")
            .attr("id", idRandom)
            .appendTo("#comparison-charts");


            $("<div></div>")
            .addClass("canvas")
            .appendTo(a);

          var temporada = temporadas[i];
          var nameChart = sectores_name[i] + " ( "+ temporada.periodo +" )";

          var fechaInicio   = new Date(temporada.inicio);
          var fechaFin      = new Date(temporada.fin);

          if(vm.isMobile){
            fechaInicio = moment(fechaFin).subtract(30, "days").toDate();
          }

          //INIT PROMISES
          var d = {
            sector_riego_id : sector_id,
            fecha_inicio    : fechaInicio,
            fecha_fin       : fechaFin,
          };

          var debugTable = {
            sector_riego_id : sector_id,
            dias            : d,
            fecha_inicio    : fechaInicio,
            fecha_fin       : fechaFin,
            vinedo_id       : vm.cuartel.vinedo_id
          };

          // /sector-riego/temporada
          var sectorProm = CuartelRes.getTemporada(d).$promise;

          var d = moment(fechaFin).diff(moment(fechaInicio), "days");
          var dataHttp = {
            "sectores_riego_id[]" : [sector_id],
            dias                  : d,
            fecha                 : fechaFin,
            vinedo_id             : vm.cuartel.vinedo_id
          };

          if(params !== undefined && params.dataHttp !== undefined){
            angular.merge(dataHttp, params.dataHttp);
          }

          // /seguimiento/dias
          var analisisProm = seguimientoRes.dias(dataHttp).$promise;

          var promMensajes = CuartelRes.getMensaje({
            sector_riego_id : sector_id,
            fecha_inicio    : fechaInicio,
            fecha_fin       : fechaFin
          });

          var promEstados = CuartelRes.getEstados({
            sector_riego_id : sector_id,
          }).$promise;

          /*
          var promSensores = VinedoRes.getSensores({
            vinedo_id : vm.cuartel.vinedo_id,
            fecha_inicio    : fechaInicio,
            fecha_fin       : fechaFin
          }).$promise;
          */





          //THEN PROMISES
          $q.all([
            analisisProm,  // peticion /seguimiento/dias
            sectorProm,    // peticion /sector-riego/temporada
            promMensajes,  // peticion /sector-riego/mensaje
            promEstados,   // peticion /sector-riego/estados
            //promSensores   // peticion /vinedo/sensores
          ]).then(function(res){

            var dataAnalisis           = res[0]; //only merge
            var data                   = res[1];
            var mensajes                = res[2].data.mensajes;
            var estadosCuartel          = res[3].data;
            //var dataSensores           = res[4].data;
            var sectorSensorSelected = _.first(data.data.sectores);
            ur                       = data.data.variables.ur;
            cc                       = data.data.variables.cc;
            pmp                      = data.data.variables.ppm;
            vm.sumar                 = data.data.variables.sumar;

            vm.loadingGeneral          = false;
            //vm.table                   = data.data.tabla;
            //vm.cuartel.precipitacion   = data.data.precipitacion;
            //vm.cuartel.precipitaciones = data.data.precipitaciones;






            //asigna UR, CC, PMP a sector de riego
            /*
            _.each(dataSensores.sectores, function(sectorSensor){
              _.each(sectorSensor.sectores_riego, function(sectorRiego){
                if(sectorRiego.id == sector_id){
                  ur       = sectorSensor.ur;
                  cc       = sectorSensor.cc;
                  pmp      = sectorSensor.pmp;
                  vm.sumar = sectorSensor.sumar;
                  //sectorSensorSelected = sectorSensor;
                }
              });
            });
            */





            //agrega limite de scholander a datos del sector (array data.data.riego)
            _.each(data.data.riego, function(r, index){
              _.each(estadosCuartel, function(estado){
                var mi = moment(estado.fecha_inicio * 1000);
                var mf = moment(estado.fecha_fin * 1000);
                var m  = moment(r.unix * 1000);
                if(r.limite_scholander === undefined){
                  r.limite_scholander = null;
                }
                if(m.isBetween(mi, mf, null, "[]")){
                  r.limite_scholander = estado.limite_scholander;
                }
              });
            });




            var datosMerge = ["bomba", "porometro", "calibre", "gramaje" ];
            //agrega variables al array data.data.riego (variables de la misma respuesta)
            _.each(data.data.riego, function(r, index){
              _.each(datosMerge, function(dm){
                if(r.unix == data.data[dm].dias[index].unix){
                  r[dm] = data.data[dm].dias[index].cantidad;
                }
              });
            });



            //from dataAnalisis to data.data.riego
            var datosMerge = ["coeficiente", "reposicion_eto", "reposicion_etb",
                              //"riego_real",
                              "eto", "etb",
                              "reposicion_ideal", "volumen_ha", "volumen_total",
                              "volumen_ha_teorico_etb", "volumen_ha_teorico_etb"];



            //agrega variables al array data.data.riego
            _.each(data.data.riego, function(r, index){
              var founded = false;
              var m = moment.unix(r.unix).add(12, "hours");
              _.each(dataAnalisis.data.datos, function(da, indexDa){
                if(m.isSame(moment(da.fecha), "day")){
                  founded = true;
                  _.each(datosMerge, function(dm){
                    r[dm] = da[dm];
                  });
                }
              });
            });





            // filtra segun fechaInicio y fechaFin
            var sectores = null;
            if(sectorSensorSelected){
              sectores = filtrarSectoresSensor(sectorSensorSelected, fechaInicio, fechaFin);
            }

            var unixInicioRiego = null;



            // <editor-fold> inicializacion de variables
              var datosEtb           = [];
              var datosEt0           = [];
              var datosEtc           = [];
              var datosProg          = [];
              var datosReal          = [];
              var datosGd            = [];
              var datosHf            = [];
              var datosPrecip        = [];
              var datosEtAcumulada   = [];
              var datosEt0Acumulada  = [];
              var datosEtbAcumulada  = [];
              var datosEtSimulada    = [];
              var datosEtcSimulada   = [];
              var datosRiegoSimulado = [];
              var datosReposicion    = [];
              var datosReposicion2   = [];
              var datosReposicionEto = [];
              var datosReposicionEtb = [];
              var datosGramos        = [];
              var datosCalibre       = [];
              var datosRiegoIdeal    = [];
              var datosScholander    = [];
              var datosTempMax       = [];
              var datosTempMin       = [];
              var datosTempAll       = [];
              var datosLimite        = [];
            //</editor-fold>

          angular.forEach(data.data.riego, function (riego) {
            if(riego.temperatura !== null){
              datosTempMax.push([riego.unix*1000, parseFloat(riego.temperatura)]);
            }

            if(riego.temperatura_min !== null){
              datosTempMin.push([riego.unix*1000, parseFloat(riego.temperatura_min)]);
            }

            if(riego.temperatura_min !== null && riego.temperatura !== null){
              if(riego.temperatura_min != 0 && riego.temperatura !=0){
                datosTempAll.push([riego.unix*1000, parseFloat(riego.temperatura_min), parseFloat(riego.temperatura), ]);
              }
            }

            if (riego.cantidad === null ||riego.cantidad === 0) {
            }else{
              datosGramos.push([riego.unix*1000, parseFloat(riego.cantidad)]);
            }
            if (riego.cantidad === null ||riego.cantidad === 0) {
            }else{
              datosCalibre.push([riego.unix*1000, parseFloat(riego.cantidad)]);
            }


            if (riego.reposicion_eto === null || riego.reposicion_eto === 0) {
              //datosReposicionEto.push([riego.unix*1000, null]);
            }else{
              datosReposicionEto.push([riego.unix*1000, parseFloat(riego.reposicion_eto)]);
            }

            if (riego.reposicion === null || riego.reposicion === 0) {
              //datosReposicion.push([riego.unix*1000, null]);
            }else{
              datosReposicion.push([riego.unix*1000, parseFloat(riego.reposicion)]);
            }

            if (riego.reposicion2 === null || riego.reposicion2 === 0) {
              //datosReposicion.push([riego.unix*1000, null]);
            }else{
              datosReposicion2.push([riego.unix*1000, parseFloat(riego.reposicion2)]);
            }



            if (riego.reposicion_etb === null || riego.reposicion_etb === 0) {
              //datosReposicionEtb.push([riego.unix*1000, null]);
            }else{
              datosReposicionEtb.push([riego.unix*1000, parseFloat(riego.reposicion_etb)]);
            }

            if (riego.etb === null || riego.etb === 0) {
              //datosEtb.push([riego.unix*1000, null]);
            }else{
              datosEtb.push([riego.unix*1000, _.round(parseFloat(riego.etb), 2)]);
            }

            if (riego.et0 === null || riego.et0 === 0) {
              //datosEt0.push([riego.unix*1000, null]);
            }else{
              datosEt0.push([riego.unix*1000, _.round(parseFloat(riego.et0), 2)]);
            }

            if ( riego.etc === null || riego.etc === 0) {
              //datosEtc.push([riego.unix*1000, null]);
            }else{
              datosEtc.push([riego.unix*1000, _.round(parseFloat(riego.etc), 2)]);
            }

            if  (riego.riego_programado === null || riego.riego_programado === 0) {
              datosProg.push([riego.unix*1000, null]);
            }else{
              datosProg.push([riego.unix*1000, parseFloat(riego.riego_programado)]); //XXX no viene
            }

            if  (riego.riegoIdeal ===  undefined || riego.riegoIdeal === 0) {
              datosRiegoIdeal.push([riego.unix*1000, null]);
            }else{
              datosRiegoIdeal.push([riego.unix*1000, parseFloat(riego.riegoIdeal)]);
            }

            if  (riego.riego_real === null || riego.riego_real === 0) {
              datosReal.push([riego.unix*1000, null]);
            }else{
              datosReal.push([riego.unix*1000, _.round(parseFloat(riego.riego_real), 1)]);
              if(unixInicioRiego === null){
                unixInicioRiego = riego.unix;
              }
            }

            if  (riego.horas_frio === null || riego.horas_frio === 0) {
              datosHf.push([riego.unix*1000, null]);
            }else{
              datosHf.push([riego.unix*1000, _.round(parseFloat(riego.horas_frio ))]);
            }

            if  (riego.grados_dia=== null || riego.grados_dia=== 0) {
              datosGd.push([riego.unix*1000, null]);
            }else{
              datosGd.push([riego.unix*1000, parseFloat(riego.grados_dia)]);
            }

            if  (riego.precipitacion === null || riego.precipitacion === 0) {
              datosPrecip.push([riego.unix*1000, null]);
            }else{
              datosPrecip.push([riego.unix*1000, _.round(parseFloat(riego.precipitacion), 2)]);
            }

            if  (riego.et0_acum === null || riego.et0_acum === 0) {
              //datosEt0Acumulada.push([riego.unix*1000, null]);
            }else{
              if(unixInicioRiego !== null && riego.unix >= unixInicioRiego){
                datosEt0Acumulada.push([riego.unix*1000, parseFloat(riego.et0_acum)]);
              }else{
                //datosEt0Acumulada.push([riego.unix*1000, null]);
              }
            }

            if  (riego.et === null || riego.et === 0) {
              //datosEtAcumulada.push([riego.unix*1000, null]);
            }else{
              datosEtAcumulada.push([riego.unix*1000, parseFloat(riego.et)]);
            }

            if  (riego.etb_acum === null || riego.etb_acum === 0) {
              //datosEtbAcumulada.push([riego.unix*1000, null]);
            }else{
              datosEtbAcumulada.push([riego.unix*1000, parseFloat(riego.etb_acum)]);
            }

            if  (riego.etc_acum_simulada === null || riego.etc_acum_simulada === 0) {
              //datosEtcSimulada.push([riego.unix*1000, null]);
            }else{
              datosEtcSimulada.push([riego.unix*1000, _.round(parseFloat(riego.etc_acum_simulada), 2)]);
            }

            if  (riego.et_acum_simulada === null || riego.et_acum_simulada === 0) {
              //datosEtSimulada.push([riego.unix*1000, null]);
            }else{
              datosEtSimulada.push([riego.unix*1000, _.round(parseFloat(riego.et_acum_simulada), 2)]);
            }

            if  (riego.riego_simulado === null || riego.riego_simulado=== 0) {
              datosRiegoSimulado.push([riego.unix*1000, null]);
            }else{
              datosRiegoSimulado.push([riego.unix*1000, parseFloat(riego.riego_simulado)]);
            }

            if  (riego.bomba === null || riego.bomba === 0) {
              datosScholander.push([riego.unix*1000, null]);
            }else{
              datosScholander.push([riego.unix*1000, parseFloat(riego.bomba)]);
            }

            if  (riego.limite_scholander === null || riego.limite_scholander === 0) {
              datosLimite.push([riego.unix*1000, null]);
            }else{
              datosLimite.push([riego.unix*1000, parseFloat(riego.limite_scholander )]);
            }

          });




            var irriviewChart = new IrriviewFac({
              title     : nameChart,
              withNotes : false,
              rangeSelected: 2,
              events    : {
                redraw: function(e){
                  var that = this;
                  $timeout(function(){

                    /*
                     * vm.relativePositions  es para posicionar
                     *  botones unfold (botones que agrandan los graficos)
                     */
                    vm.relativePositions = irriviewChart.getRelativePositions();
                    vm.plotHeight        = that.plotHeight;
                    vm.plotTop           = that.plotTop;

                    _.each(vm.relativePositions, function(p){
                      if(typeof p.top == "string"){
                        p.top = (parseFloat(p.top)/100) * vm.plotHeight;
                      }
                      if(typeof p.height== "string"){
                        p.height = (parseFloat(p.height )/100) * vm.plotHeight;
                      }
                    });
                  });
                },
                load: function(){
                  if(vm.conEstados){
                    vm.showAllEstados();
                  }
                }
              }
            }); //end new IrriviewFac

            //vm.expandChart = irriviewChart.expandChart;
            //vm.reloadSum   = irriviewChart.reloadSum;
            //vm.reloadProm  = irriviewChart.reloadProm;
            //vm.reloadIndex = irriviewChart.reloadIndex;
            //vm.getSerieBy  = irriviewChart.getSerieBy;





            // <editor-fold> determina ejes para datos


            var yaxis_temp_index = undefined;
            var yaxis_gd_index  = undefined;
            /*
            yaxis_temp_index = irriviewChart.addYAxis({
              text     : 'temperatura',
              position : 0,
              background: "rgba(0, 0, 0, 0.1)"
            });
            */

            yaxis_gd_index = irriviewChart.addYAxis({
              text     : 'grados Dia',
              position : 0,
              visible  : false,
            });

            var yaxis_sch_index = irriviewChart.addYAxis({
              text     : 'Scholander',
              position : 0,
              visible  : false
            });

            var yaxis_mm_index = irriviewChart.addYAxis({
              text     : 'mm',
              position : 0,
            });

            var yaxis_porcentaje_index = irriviewChart.addYAxis({
              text     : 'porcentaje',
              opposite : true,
              position : 0,
              //visible  : false,
            });

            var yaxis_volume_index = irriviewChart.addYAxis({
              text     : 'volume',
              position : 0,
              visible  : false,
            });




            var yaxis_ss_index = undefined;
            var yaxis_in_index = undefined;
            if(sectores && sectores.length > 0){

              var yaxis_ss_index = irriviewChart.addYAxis({
                text     : 'humedad',
                position : 2,
              });

              var yaxis_in_index = irriviewChart.addYAxis({
                text     : 'indice',
                position : 2,
                visible:false
              });

              var yaxis_sensor_index = irriviewChart.addYAxis({
                text     : 'humedad',
                position : 1,
                //background: "rgba(0, 0, 0, 0.1)",
                stackeable:{
                  enabled: true,
                  //min: 0,
                  //max: 60,
                }
              });


            vm.yaxis_sensor_index = yaxis_sensor_index;

            }

            // </editor-fold>


            //<editor-fold> Agrega las series de datos en irriviewChart



            irriviewChart.addSerie(
              {
                id         : _.random(10, 100000),
                name       : 'Etc',
                color      : Config.colors.etc.background,
                data       : datosEtc,
                visible    : false,
                type       : 'area',
                step       : "left",
                yAxis      : yaxis_mm_index,
                pointRange : 24 * 3600 * 1000,
                tooltip    : {
                  valueSuffix: " mm"
                },
                ruler      : {
                  enabled : true,
                  delta   : false,
                  sum     : true
                },
                dataGrouping:{
                  units: [[
                    'day',
                    [1]
                  ]]
                }
              }
            );

            irriviewChart.addSerie(
              {
                id          : _.random(10, 100000),
                name        : 'Et0',
                color       : Config.colors.et0.alt,
                fillOpacity : 1,
                data        : datosEt0,
                type        : 'area',
                step        : "left",
                tag         : "eto",
                yAxis       : yaxis_mm_index,
                pointRange  : 24 * 3600 * 1000,
                tooltip    : {
                  valueSuffix: " mm"
                },
                visible   : false, //Config.vinedo['estacionMet'],
                /*dataLabels  : {
                  enabled: true,
                  align: "left",
                  x: 5
                },*/
                ruler      : {
                  enabled: true,
                  delta:false,
                  sum: true
                }
              }
            );



            irriviewChart.addSerie({
                name        : 'Et0 acum',
                color       : Config.colors.et0.alt,
                fillOpacity : 1,
                data        : datosEt0Acumulada,
                type        : 'spline',
                yAxis       : yaxis_mm_index,
                tooltip    : {
                  valueSuffix: " mm"
                },
                label : false,
                pointRange  : 24 * 3600 * 1000,
                //visible   : Config.vinedo['estacionMet'],
                ruler      : {
                  enabled: true,
                  delta:false,
                  sum: true
                }
              });


            irriviewChart.addSerie({
                name        : 'Etb acum',
                color       : Config.colors.etb.alt,
                fillOpacity : 1,
                data        : datosEtbAcumulada,
                type        : 'spline',
                yAxis       : yaxis_mm_index,
                tooltip    : {
                  valueSuffix: " mm"
                },
                pointRange  : 24 * 3600 * 1000,
                //visible   : Config.vinedo['estacionMet'],
                ruler      : {
                  enabled: true,
                  delta:false,
                  sum: true
                }
              });





            irriviewChart.addSerie(
              {
                id          : _.random(10, 100000),
                name        : 'Etb',
                color       : Config.colors.etb.background,
                fillOpacity : 1,
                data        : datosEtb,
                type        : 'area',
                step        : "left",
                tag         : "eto",
                yAxis       : yaxis_mm_index,
                tooltip    : {
                  valueSuffix: " mm"
                },
                pointRange  : 24 * 3600 * 1000,
                visible   : false, //Config.vinedo['conBandeja'],
                /*
                dataLabels  : {
                  enabled: true,
                  align: "left",
                  x: 5
                },
                */
                ruler      : {
                  enabled: true,
                  delta:false,
                  sum: true
                }
              }
            );



            if(!vm.config.vinedo.mai){
              irriviewChart.addSerie({
                id                  : _.random(10, 100000),
                name                : 'limite scholander',
                data                : datosLimite,
                lineColor           : Config.colors.scholander.background,
                color               : Config.colors.scholander.background,
                fillOpacity         : 0.2,
                type                : 'area',
                yAxis               : yaxis_sch_index,
                lineWidth           : 1,
                //enableMouseTracking : false,
                step                : "left",
                //dashStyle           : "DashDot"
              }
            );
          }




            irriviewChart.addSerie({
                id         : _.random(10, 100000),
                name       : 'Scholander',
                data       : datosScholander,
                color      : Config.colors.scholander.background,
                type       : 'spline',
                yAxis      : yaxis_sch_index,
                tooltip    : {
                  valueSuffix: " bar",
                  valuePreffix: "-"
                },
                pointRange : 24 * 3600 * 1000,
                lineWidth  : 0,
                marker     : {
                  enabled:true,
                  radius: 4,
                  symbol:"triangle-down"
                },
                dataLabels:{
                  enabled: true
                }
              }
            );


            /*
            irriviewChart.addSerie({
              id         : _.random(10, 100000),
              name       : 'Reposición Eto',
              data       : datosReposicionEto,
              color      : Config.colors.riegoReal.background,
              type       : 'spline',
              yAxis      : yaxis_porcentaje_index,
              visible:false,
              tooltip    : {
                valueSuffix: "%",
              },
            });


            irriviewChart.addSerie({
              id         : _.random(10, 100000),
              name       : 'Reposición Etb',
              data       : datosReposicionEtb,
              color      : Config.colors.etb.background,
              type       : 'spline',
              yAxis      : yaxis_porcentaje_index,
              visible:false,
              tooltip    : {
                valueSuffix: "%",
              },
            });
            */


            irriviewChart.addSerie({
              id         : _.random(10, 100000),
              name       : 'Reposición',
              data       : datosReposicion,
              color      : Config.colors.riegoReal.background,
              type       : 'spline',
              yAxis      : yaxis_porcentaje_index,
              //visible:false,
              tooltip    : {
                valueSuffix: "%",
              },
            });

            /*
            irriviewChart.addSerie({
              id         : _.random(10, 100000),
              name       : 'Reposición 2',
              data       : datosReposicion2,
              color      : Config.colors.riego,
              type       : 'spline',
              yAxis      : yaxis_porcentaje_index,
              visible:false,
              tooltip    : {
                valueSuffix: "%",
              },
            });
            */








            irriviewChart.addSerie({
              id         : _.random(10, 100000),
              name       : 'Riego Real',
              data       : datosReal,
              color      : Config.colors.riegoReal.background,
              type       : 'column',
              yAxis      : yaxis_mm_index,
              pointRange : 24 * 3600 * 1000,
              dataLabels:{
                enabled: true,
                color      : Config.colors.riegoReal.background,
              },
              tooltip    : {
                valueSuffix: " mm",
            pointFormatter : function() {
              var icon = '<i class="fa fa-square" aria-hidden="true"></i>';
              return '<span style="color:' +Config.colors.riegoReal.background +
                '">'+icon+'</span> Riego Real: <span style="white-space:nowrap; font-weight: bold">'+
                getVarDatosRiego(data.data.riego, this.x, "riego_real")+'mm - '+
                numToHourString(getVarDatosRiego(data.data.riego, this.x, "riego_real_h"))+' Hrs</span>';
            }



              },
              ruler      : {
                enabled : true,
                delta   : false,
                sum     : true
              }
            });


            irriviewChart.addSerie(
                {
                  id         : _.random(10, 100000),
                  name       : 'Riego Programado',
                  data       : datosProg,
                  color      : Config.colors.riegoProgramado.background,
                  type       : 'column',
                  yAxis      : yaxis_mm_index,
                  pointRange : 24 * 3600 * 1000,
                  visible    : false,
                  tooltip    : {
                    valueSuffix: " mm",
                  },
                }
            );


            irriviewChart.addSerie(
              {
                id         : _.random(10, 100000),
                name       : 'Precipitaciones',
                color      : Config.colors.precipitacion.background,
                data       : datosPrecip,
                type       : 'column',
                yAxis      : yaxis_mm_index,
                pointRange : 24 * 3600 * 1000,
                  tooltip    : {
                    valueSuffix: " mm",
                  },
              }
            );

            /*
            irriviewChart.addSerie(
              {
                id         : _.random(10, 100000),
                name       : 'Reposicion',
                data       : datosReposicion,
                color      : Config.colors.riegoReal.background,
                type       : 'spline',
                yAxis      : 4,
                pointRange : 24 * 3600 * 1000,
                visible    : false
              }
            );
            */

            if(yaxis_temp_index !== undefined){
              irriviewChart.addSerie(
                {
                  id      : _.random(10, 100000),
                  name    : 'temperaturaMax',
                  color   : Config.colors.temperatura.max,
                  data    : datosTempMax,
                  type    : 'spline',
                  yAxis   : yaxis_temp_index,
                  visible : false,
                  tooltip    : {
                    valueSuffix: " ºC",
                  },
                }
              );

              irriviewChart.addSerie(
                {
                  id      : _.random(10, 100000),
                  name    : 'temperaturaMin',
                  color   : Config.colors.temperatura.min,
                  data    : datosTempMin,
                  type    : 'spline',
                  yAxis   : yaxis_temp_index,
                  visible : false,
                  tooltip    : {
                    valueSuffix: " ºC",
                  },
                }
              );
            }













            var dataSensor       = {};
            var correlacion      = {};
            var dataSumSensores  = [];
            var dataPromSensores = [];

            if(sectores && sectores.length > 0){
              /*
               * lee array de sectores (sectores sensor)
               * con orden [[fecha, s1, s2, s3...]]
               * correlaciona las alturas con los datos y genera dataSensor[altura] = [[unix, dato]]
               * genera dataSumSensores con formato [[unix, sumaAlturas]]
               * genera dataPromSensores con formato [[unix, promedioAlturas]]
               *
               */
              _.each(sectores, function(sensor, index){
                if(index == 0){ //la posicion 0 es para determinar las alturas, no contiene datos
                  _.each(sensor, function(h, i){
                    if(i >0){
                      dataSensor[h] = [];
                      correlacion[i] = h;
                    }
                  });
                }else{
                  var unix = moment.utc(sensor[0], "X").unix() * 1000;
                  var sum  = 0;
                  var count = 0;
                  _.each(sensor, function(d, i){
                    if(i >0){
                      dataSensor[correlacion[i]].push([unix, _.round(d, 2)]);
                      sum += d;
                      count ++;
                    }
                  });
                  dataSumSensores.push([unix, _.round(sum, 1)]);
                  dataPromSensores.push([unix, _.round(sum / count- 1, 1)]);
                }
              });




              _.each(dataSensor, function(ds, index){
                if(isLem){
                  ds = normalizarSensor(ds, index, sectorSensorData);
                }
                irriviewChart.addSerie({
                  id      : _.random(10, 100000),
                  type    : 'line',
                  abbr    : "s "+index,
                  name    : "sensor "+index+"cm",
                  profundidad: parseFloat(index),
                  data    : ds,
                  sumTo   : "ss",
                  promTo  : "ss",
                  stackeable      : true,
                  indexTo : "",
                  tooltip    : {
                    valueSuffix: " %",
                  },
                  ruler   : {
                    enabled : true,
                    delta   : true,
                    sum     : false
                  },
                  yAxis         : yaxis_sensor_index,
                });
              });




              if(yaxis_in_index !== undefined){
                irriviewChart.addSerie({
                  id           : _.random(10, 100000),
                  name         : "kc",
                  tag          : "kc",
                  type         : 'spline',
                  lineWidth    : 0,
                  //data         : deltasSensor.delta,
                  data         : [],
                  yAxis        : yaxis_in_index,
                  color        : "orange",
                  dataGrouping : {enabled: false},
                  tooltip      : {
                    pointFormatter: function(){
                      if(vm.deltasSensor){
                        return getByMoment(moment(this.x), vm.deltasSensor.labels);
                      }
                    }
                  },
                  marker       : {
                    enabled: true,
                    radius: 2
                  },
                  dataLabels: {
                    enabled: true
                  },
                });
              }



              if(yaxis_ss_index !== undefined){
                irriviewChart.addSerie({
                  id              : _.random(10, 100000),
                  name            : "promedio sensores",
                  abbr            : "prom",
                  promId          : "ss",
                  type            : "line",
                  data            :dataPromSensores,
                  yAxis           : yaxis_ss_index,
                  color           : "black",
                  showInNavigator : true,
                  visible: !vm.sumar,
                  tooltip    : {
                    valueSuffix: " %",
                  },
                  ruler           : {
                    enabled : true,
                    delta   : true,
                    sum     : false
                  },
                  datagrouping      : {
                    grouppixelwidth : 1,
                    units           : [[
                      'minute',
                      [15, 30]
                    ],[
                      'hour',
                      [1,6]
                    ]]
                  }
                });
              }








              if(yaxis_ss_index !== undefined){
                irriviewChart.addSerie({
                  id              : _.random(10, 100000),
                  name            : "suma sensores",
                  abbr            : "ss",
                  sumId           : "ss",
                  type            : "line",
                  data            : dataSumSensores,
                  yAxis           : yaxis_ss_index,
                  color           : "black",
                  visible: vm.sumar,
                  showInNavigator : true,
                  tooltip    : {
                    valueSuffix: " %",
                  },
                  ruler           : {
                    enabled : true,
                    delta   : true,
                    sum     : false
                  },
                  datagrouping      : {
                    grouppixelwidth : 1,
                    units           : [[
                      'minute',
                      [15, 30]
                    ],[
                      'hour',
                      [1,6]
                    ]]
                  }
                });
              }








              //var pmp         = data.data.variables.ppm; // backend typo
              //var cc          = data.data.variables.cc;
              //var ur          = data.data.variables.saturacion;
              var coeficiente = 1;

              /*
              if(data.data.sectores.length > 0 &&
                data.data.sectores[0].length > 0 &&
                data.data.sectores[0][0].length > 0){
                coeficiente = data.data.sectores[0][0].length - 1;
              }
              */

              ur  *= coeficiente;
              pmp *= coeficiente;
              cc  *= coeficiente;

              if (ur > 0){
                irriviewChart.addPlotLineY({
                  color : Config.colors["ur"].background,
                  width : 2,
                  value : ur,
                  yAxis: yaxis_sensor_index,
                  label : {
                    text      : "UR "+ur+"%",
                    align     : "left",
                    textAlign : "left",
                    x         : 20
                  }
                });
              }

              if (cc > 0) {
                irriviewChart.addPlotBandY({
                  color : Config.colors["saturacion"].backgroundRGBA,
                  to    : cc + 50,
                  from  : cc,
                  yAxis: yaxis_sensor_index,
                  label : {
                    text      : "Sat > " + cc + "%",
                    align     : "right",
                    textAlign : "right",
                    x         : -20
                  },
                });

                irriviewChart.addPlotBandY({
                  color  : Config.colors["cc"].backgroundRGBA,
                  to     : pmp,
                  from   : cc,
                  yAxis: yaxis_sensor_index,
                  labels : {
                    text      : "CC " + cc + "%",
                    align     : "right",
                    textAlign : "right",
                    x         : -20
                  },
                });
              }  // end cc > 0

              if (pmp > 0) {
                irriviewChart.addPlotBandY({
                  color : Config.colors["pmp"].backgroundRGBA,
                  to    : pmp,
                  from  : pmp - 10,
                  yAxis: yaxis_sensor_index,
                  label : {
                    text      : "pmp " + pmp + "%",
                    align     : "right",
                    textAlign : "right",
                    x         : -20
                  },
                });
              } //end pmp > 0
            } // end if sectores.length > 0

            //var axis = 1;







            var serieTempId = _.random(10, 100000);

            if(yaxis_temp_index !== undefined){
              irriviewChart.addSerie({
                id        : serieTempId,
                name      : 'temperatura',
                data      : datosTempAll,
                type      : 'arearange',
                yAxis     : yaxis_temp_index,
                color     : "#f44336",
                fillColor : "#f44336",
                tooltip    : {
                  valueSuffix: " ºC",
                },
                zones     : []
              });
            }


            if(yaxis_gd_index !== undefined){
              irriviewChart.addSerie({
                id      : _.random(10, 100000),
                name    : 'grados Dia',
                color   : Config.colors.gd.background,
                data    : datosGd,
                type    : 'spline',
                yAxis   : yaxis_gd_index,
                visible : false
              });

              irriviewChart.addSerie({
                id      : _.random(10, 100000),
                name    : 'Horas Frio',
                color   : Config.colors.etb.background,
                data    : datosHf,
                type    : 'spline',
                yAxis   : yaxis_gd_index,
                visible : false
              });
            }


            _.each( rulers, function(r){

              if((r.line === undefined || r.line) && yaxis_temp_index !== undefined){
                irriviewChart.addPlotLineY({
                  color     : r.lineColor,
                  yAxis     : yaxis_temp_index,
                  width     : 1,
                  value     : r.num,
                  dashStyle : "longdashdotdot",
                  label     : {
                    text      : r.name,
                    align     : "right",
                    textAlign : "right",
                    x         : -20,
                    style     : {
                      //color: r.lineColor,
                    }
                  }
                });
              }

              irriviewChart.addSerieZone({
                serieId   : serieTempId,
                color     : r.warningColor,
                fillColor : r.fillColor || r.warningColor,
                value     : r.num
              });

            });




            var dataMensajes = [];
            _.each(mensajes, function(m){
              if(m.mensajes !== undefined && m.mensajes[0].msj !== ""){
                var date = moment(m.unix * 1000).format("DD, MMM");
                var newM = {
                  x     : m.unix * 1000,
                  title : "msj",
                  //title   : '<span class="msj-icon"><i class="material-icons">chat</i></span>',
                  //m.mensajes[0].nombre_user,
                  text  : m.mensajes[0].msj,
                  name  : "<b>"+m.mensajes[0].nombre_user+" : </b> <i class='md-blue'>"+ date + "</i>",
                };
                dataMensajes.push(newM);
              }
            });



            irriviewChart.addSerie({
              name      : "mensajes",
              data      : dataMensajes,
              type      : "flags",
              yAxis     : yaxis_mm_index,
              shape     : 'flag',
              className:"serie-mensajes",
              useHTML   : true,
              lineColor : "#616161",
              fillColor : "#616161",
              color     : "#fff",
              lineWidth : 2,
              y         : -40,
              label:{
                style:{
                  color: "red"
                }
              },
              states    : {
                hover:{
                  fillColor: "#424242",
                  brightness: 0
                }
              }
            });


            //</editor-fold>


            irriviewChart.addTodayLine();


            var chart = irriviewChart.show(idRandom);

            vm.charts.push({
              sector_id  : sector_id,
              estados    : estadosCuartel,
              chart      : chart,
              temporada  : temporada,
              estadosIds : []
            });


            var estadosHTMLContent = $("<div ng-repeat='c in iv.charts' ng-show='c.sector_id == "+sector_id+" && c.temporada.periodo == \""+temporada.periodo+"\" '>"+"</div>");
            estadosHTMLContent.addClass("estados-lista");
            var templateUrl = 'components/cuartel/irriview/listaEstados_tmpl.html';

            $templateRequest(templateUrl).then(function(template) {
              estadosHTMLContent.append(template);
              $compile(estadosHTMLContent).bind(vm)($scope);
              a.prepend(estadosHTMLContent);
            }, function() {
              // An error has occurred
            });


            //vm.chart      = chart;

            stackHSSeries(chart, yaxis_sensor_index);

            a.find(".highcharts-navigator, .highcharts-scrollbar, .highcharts-legend")
              .on("mouseover", function(e){
                $timeout(function(){
                  vm.showNotes = false;
                  //vm.showSerieLabel = false;
                })
              }).on("mouseleave", function(e){
                $timeout(function(){
                  vm.showNotes = true;
                  //vm.showSerieLabel = true;
                });
              });


          });





        });
      };











        vm.removeAllEstados = function(){
          vm.conEstados = false;
          _.each(vm.charts, function(chartItem){
              vm.removeEstados(chartItem)
          });
        }

        vm.removeEstados = function(chartItem){
          _.each(chartItem.estadosIds, function(id){
            chartItem.chart.xAxis[0].removePlotBand(id);
          });
          chartItem.estadosIds = [];
        }

        vm.showAllEstados = function(){
          vm.conEstados = true;
          _.each(vm.charts, function(chartItem){
              vm.showEstados(chartItem)
          });
        }


        vm.showEstados = function(chartItem) {
          var estadosIds    = chartItem.estadosIds;
          var estados       = chartItem.estados;
          var chart         = chartItem.chart;
          var temporada     = chartItem.temporada;

          _.each(estados, function(estado, key) {
            if(vm.verificarPeriodo(estado, temporada)){

              estado.inicio = moment.unix(estado.fecha_inicio).hours(0).minutes(0).unix();
              if (estado.final == 0) {
                estado.final = moment().hours(23).minutes(59).unix();
              }else{
                estado.final = moment.unix(estado.fecha_fin).hours(23).minutes(59).unix();
              }

              var id_estado = _.random(1000000, 999999);
              estadosIds.push(id_estado);

              chart.xAxis[0].addPlotBand({
                id          : id_estado,
                color       : vm.convertHex(Config.colors.list[key], 5),
                borderColor : Config.colors.list[key],
                borderWidth : 1,
                from        : estado.inicio * 1000,
                to          : estado.final* 1000,
                zIndex      : 2,
                label       : {
                  textAlign : "left",
                  align     : "left",
                  y         : -10,
                  style     : {
                    color    : 'black',
                    fontSize : 10
                  },
                },
              });

            }
          });
        }




        vm.toggleEstados = function(){
              if(vm.conEstados){
                vm.showAllEstados();
              }else{
                vm.removeAllEstados();
              }
        }

        vm.toggleEstadosChart = function(chartItem){
          if(chartItem.estadosIds.length > 0){
            vm.removeEstados(chartItem);
            return;
          }
          vm.showEstados(chartItem);
        }








        vm.changeTemporada = function (temporada) {
          vm.temporadaSelected = temporada;
          fechaInicio          = new Date(vm.temporadaSelected.inicio);
          fechaFin             = new Date(vm.temporadaSelected.fin);
          if(vm.isMobile){
            fechaInicio = moment(fechaFin).subtract(30, "days").toDate();
          }
          //vm.loadingGeneral    = true;
          //vm.initChart();
          vm.optionsChanged = true;
        };














        //init
        var promTemp = temporadaFac.getTemporadas();

        var promCuartel = CuartelRes.getData({
          sector_riego_id : cuartel_id,
          fecha           : null
        }).$promise;

        $q.all([promTemp, promCuartel]).then(function(res){
          vm.cuartel = res[1].data;

          //codigo sacado de routes
          //para datos globales para titulo y permisos
          if(!isDialog){
            var variedades = "";
            var calidades  = "";

            angular.forEach(vm.cuartel.variedades, function(variedad){
              variedades += variedad.nombre + " ";
              calidades  += variedad.calidades[0].nombre + " ";
            });

            vm.vinedo_nombre = vm.cuartel.vinedo_nombre;

            global.title     = vm.cuartel.nombre;//+" ("+variedades+" / "+calidades+")";
            global.titleData = [
              {
                name : 'Variedades',
                data : variedades
              },
              {
                name : 'Calidades',
                data : calidades
              },{
                name : 'Viñedo',
                data : vm.cuartel.vinedo_nombre
              }];
            Config.vinedo = vm.cuartel.configuracion;
            angular.forEach(Config.vinedo, function(item, index){
              if (item == '1' || item === 1) {
                Config.vinedo[index] = true;
              }
              if (item == '0' || item === 0) {
                Config.vinedo[index] = false;
              }
            });
          } // end if !isDialog



          vm.temporadas              = res[0].data.data;
          vm.temporadaSelected       = temporadaFac.getActiva();
          vm.temporadaSelected_1     = temporadaFac.getActiva();
          vm.temporadaSelected_2     = temporadaFac.getActiva();
          vm.temporadaSelectedWindow = temporadaFac.getActiva();
          vm.temporadaComparada      = temporadaFac.getAnterior(vm.temporadaSelected);
          fechaInicio                = new Date(vm.temporadaSelected.inicio);
          //fechaFin                 = new Date(vm.temporadaSelected.fin);
          fechaFin                   = moment().add(3, "weeks").toDate();
          if(vm.isMobile){
            fechaInicio = moment(fechaFin).subtract(30, "days").toDate();
          }

          menu.getSidebarProm().then(function(){
            vm.equipos = global.getSidebarData(vm.cuartel.vinedo_id).equipos;
          });
          vm.reload (); //TODO mejorar
        });






//CL3459939740









        vm.optionsChanged = false;
        vm.selectSectoresCallback = function(){
          vm.optionsChanged = true;
        }

        vm.reload = function(){
          vm.loadingGeneral = true;
          vm.optionsChanged = false;
          var sectores_ids  = [cuartel_id]; //, select1_id, select2_id];
          var sectores_name = [vm.cuartel.nombre]; //, vm.select1.nombre, vm.select2.nombre];
          var temporadas = [vm.temporadaSelected];
          vm.charts = [];

          if(vm.select1){
            sectores_name.push(vm.select1.nombre);
            sectores_ids.push(vm.select1.id);
            temporadas.push(vm.temporadaSelected_1);
          }

          if(vm.select2){
            sectores_name.push(vm.select2.nombre);
            sectores_ids.push(vm.select2.id)
            temporadas.push(vm.temporadaSelected_2);
          }

          if(sectores_ids.length == 1){
            vm.initChart();
          }else{
            vm.initChartComparison({
              sectores_id   : sectores_ids,
              sectores_name : sectores_name,
              temporadas    : temporadas
              //elements_ids : ["test1", "test2", "test3"]
            });
          }

        };
























        var deltaFormatter = function( delta) {
          var wrapper = function(){
            if(!this.corrected_delta){
              this.y -= delta;
              this.corrected_delta = true;
            }
            return this.tooltipFormatter.apply( this, arguments );
          };
          //wrapper.format = formatter.format;
          return wrapper;
        };


        //TODO: refactor
        vm.toggleHSSeries = function(){
          if(vm.stacked){
            unstackHSSeries(vm.chart, vm.yaxis_sensor_index);
          }else{
            stackHSSeries(vm.chart, vm.yaxis_sensor_index);
          }
        }

        var unstackHSSeries = function(chart, yaxisIndex){
          vm.stacked = false;
          var yAxis = chart.yAxis[yaxisIndex];
          var serie;
          var i;
          var series = chart.xAxis[0].series;
          var data = [];

          // Search for series to be stacked
          for (i = 0; i < series.length; i++) {
            serie = series[i];

            if(serie.userOptions.stackeable){
              // Store data ranges
              data = angular.copy(serie.userOptions._data);
              serie.delta = 0;
              serie.setData(data, false);
              serie.update({
                stacked   : false,
                plotBands : plotBands,
                tooltip   : {
                  pointFormatter: undefined //fdeltaFormatter(range.delta)
                }
              }, false);

              var s_min     = yAxis.userOptions.stackeable.min;
              var s_max     = yAxis.userOptions.stackeable.max;
              var plotBands = yAxis.userOptions._plotBands;
              var plotLines = yAxis.userOptions._plotLines;
              yAxis.update({
                startOnTick : true,
                plotBands   : plotBands,
                plotLines   : plotLines,
                endOnTick   : true,
                labels      : {
                  enabled: true
                }
              }, false);
              yAxis.setExtremes(null,null,true);
            }
          }
          chart.redraw();
        }

        var stackHSSeries = function(chart, yaxisIndex) {
          vm.stacked = true;
          var yAxis = chart.yAxis[yaxisIndex];
          var serie;
          var i;
          var dataRanges = [];
          var series = chart.xAxis[0].series;

          // Search for series to be stacked
          for (i = 0; i < series.length; i++) {
            serie = series[i];

            if(serie.userOptions.stackeable){
              // Store data ranges
              serie.userOptions._data = angular.copy(serie.userOptions.data);

              dataRanges.push($.extend({
                serie : serie
              }, {
                //serie.userOptions.dataRange
                min : _.minBy(serie.userOptions.data, function(o){return o[1]})[1],
                max : _.maxBy(serie.userOptions.data, function(o){return o[1]})[1],
                avg : _.meanBy(serie.userOptions.data, function(o){return o[1]}),
              }
              ));
            }
          }
          // Need at least 1 series
          if (dataRanges.length < 1) {
            return false;
          }
          // Se calcula la reparticion de las curvas
          var s_min = yAxis.userOptions.stackeable.min;
          var s_max = yAxis.userOptions.stackeable.max;
          s_max     = s_max < yAxis.max ? yAxis.max : s_max;
          s_min     = s_min > yAxis.min ? yAxis.max : s_min;
          yAxis.userOptions._plotBands = yAxis.userOptions.plotBands;
          yAxis.userOptions._plotLines = yAxis.userOptions.plotLines;

          yAxis.setExtremes(s_min, s_max, false);
          var yAxisEx = $.extend({}, yAxis.getExtremes());

          /*
          if(yAxis.userMin < yAxis.min){
            yAxisEx.min = yAxisEx.userMin;
          }
          if(yAxis.userMax > yAxis.max){
            yAxisEx.max = yAxisEx.userMax;
          }
          */

          var yAxisMargin = (yAxisEx.max - yAxisEx.min) / 20; // 2% del eje

          // For unique serie:
          if (dataRanges.length === 1) {
            // Put at center
            dataRanges[0].delta = ((dataRanges[0].min - yAxisEx.min) + (yAxisEx.max - dataRanges[0].max)) / 2;
          }
          // For multiple series:
          else {

            // 1- Se ordena por position
            dataRanges.sort(function(r1, r2) {
              return r2.serie.userOptions.profundidad- r1.serie.userOptions.profundidad;
            });
            // 2.1- Se calcula el Delta para la primera y la ultima serie
            // para que quepe dentro de toda la zona del grafico
            dataRanges[0].delta = yAxisEx.min + yAxisMargin - dataRanges[0].min;
            var m = dataRanges.length - 1;
            dataRanges[m].delta = yAxisEx.max - yAxisMargin - dataRanges[m].max;
            // 2.2- Se calcula el factor de espacio inter-serie,
            // ponderado por la amplitude de las 2 series que se separan
            var farFactors = [];
            var farFactorsSum = 0;
            for (var i = 0; i < m; i++) {
              farFactors[i] = (dataRanges[i].max - dataRanges[i].min)
                + (dataRanges[i + 1].max - dataRanges[i + 1].min);
              farFactors[i] = (1 / (2 * m)) + farFactors[i] / 2;
              farFactorsSum += farFactors[i];
            }
            for (var i = 0; i < farFactors.length; i++) {
              farFactors[i] = farFactors[i] / farFactorsSum;
            }
            // 3- Se calcula el Delta para las demas series
            var interAvg = dataRanges[m].avg + dataRanges[m].delta
              - (dataRanges[0].avg + dataRanges[0].delta);
            for (var i = 1; i < m; i++) {
              // avg(i) = avg(i-1) + interAvg * farFactors(i-1)
              // avg(i) = avg(real) + delta
              // => delta = avg(i) - avg(real)
              dataRanges[i].delta = (dataRanges[i - 1].avg
                + dataRanges[i - 1].delta + (interAvg * farFactors[i - 1]))
                - dataRanges[i].avg;
            }
            // 4 - Se reparte el espacio inter-serie que "sobra"
            var spaces = [], space, push, avgSpace = [], yBottom = yAxisEx.min;
            for (var i = 0; i <= m; i++) {
              space = (dataRanges[i].min + dataRanges[i].delta) - yBottom;
              space = space >= yAxisMargin ? space : 0;
              if (space > 0) {
                avgSpace.push(space);
              }
              spaces.push(space);
              yBottom = dataRanges[i].max + dataRanges[i].delta;
            }
            space = yAxisEx.max - yBottom;
            space = space >= yAxisMargin ? space : 0;
            if (space > 0) {
              avgSpace.push(space);
            }
            spaces.push(space);
            if (avgSpace.length > 2) {
              avgSpace = _.mean(avgSpace);//Math.sum.apply(Math, avgSpace) / avgSpace.length;
              push = 0;
              for (var i = 0; i <= m; i++) {
                if (spaces[i] > 0) {
                  push = (avgSpace - spaces[i]) + push;
                }
                dataRanges[i].delta += push;
              }
            }
          }
          //

          // 5- Finalmente, se aplica el delta para todas las series
          var range, serie, data, d, pData;
          for (i = 0; i < dataRanges.length; i++) {
            range = dataRanges[i];
            serie = range.serie;
            data  = serie.userOptions.data; //charts.getCachedSerieData(serie);
            pData = [];


            for (var j in data) {
              d = data[j];
              pData.push([ d[0], d[1] == null ? null : _.round(d[1] + range.delta, 2) ]);
            }

            //
            serie.delta = range.delta;
            //serie.userOptions.__formatter = serie.userOptions.formatter;
            serie.setData(pData, false);
            serie.update({
              stacked: true,
              tooltip:{
                pointFormatter: deltaFormatter(range.delta)
              }
            }, false);
          }
          // Keep same axis extremes
          yAxis.update({
            startOnTick: false,
            endOnTick: false,
            plotBands:[],
            plotLines:[],
            labels:{
              enabled:false
            }
          }, false);
          yAxis.setExtremes(s_min, s_max, true);
          //yAxis.setExtremes(yAxisEx.min, yAxisEx.max, true);
          //yAxis.userOptions.labels.formatter.hidden = true;
          // Redraw
          return true;
        };




      }]);
})();
